webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(244);
	module.exports = __webpack_require__(243);


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(148);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(254);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(247);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _typeof2 = __webpack_require__(251);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(94);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(207);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _appState = __webpack_require__(239);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _brandConfig = __webpack_require__(93);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USE_MOCK_DATA = false;
	
	var PROXY_API_URL = ("https://9yzvi3t145.execute-api.ca-central-1.amazonaws.com/production-kds/kds") || 'https://9yzvi3t145.execute-api.ca-central-1.amazonaws.com/production-kds/kds';
	var VM_API_URL = ("https://aws-api.harveys.ca/CaraAPI/servlet/VESBCmdServlet") || 'https://aws-api.harveys.ca/CaraAPI/servlet/VESBCmdServlet';
	var JARVIS_API_URL = 'https://jarvis-api.recp.ca';
	
	var KDS_SERVICE_PREFIX =  true ? ("gkds_") : 'gkds_';
	var ENPOINT_LOOKUP = {
	  "6666": "http://172.31.90.7:90"
	};
	
	_axios2.default.defaults.baseURL = PROXY_API_URL;
	_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
	
	window.promises = {};
	
	window.resolveRequest = function (promiseId, data, error, status) {
	  console.log('response:' + promiseId + ' data:' + data + ' error:' + (0, _stringify2.default)(error) + ' status:' + status);
	  if (error) {
	    promises[promiseId].resolve({ error: error });
	  } else {
	    promises[promiseId].resolve({ data: data });
	  }
	
	  delete promises[promiseId];
	};
	
	exports.default = {
	  mainAPIServer: PROXY_API_URL,
	  endPoint: PROXY_API_URL,
	  useOverride: false,
	  useProxyApi: false,
	  storeSelected: false,
	  language_flag: null,
	  language: 'EN',
	  vmSessionID: null,
	  sessionRetryCount: 0,
	  station: 'kds',
	  binType: 'all',
	  brand: _brandConfig2.default.brandDefault,
	  kdsDetailView: true,
	  useMockData: USE_MOCK_DATA,
	
	  appState: _appState2.default.defaultAppState(),
	
	  apiObject: function apiObject(method, apiParameters) {
	    method = method || "post";
	    apiParameters = apiParameters || {};
	
	    var pathSuffix = '';
	    var queryString = '';
	
	    if (apiParameters.service) {
	      if (this.useProxyApi) {
	        queryString = '?service=' + KDS_SERVICE_PREFIX + apiParameters.service;
	      } else {
	        pathSuffix = KDS_SERVICE_PREFIX + apiParameters.service;
	      }
	    }
	
	    if ((0, _typeof3.default)(apiParameters.queryString) === 'object') {
	      for (var q in apiParameters.queryString) {
	        if (queryString) {
	          queryString += '&' + q + '=' + apiParameters.queryString[q];
	        } else {
	          queryString = '?' + q + '=' + apiParameters.queryString[q];
	        }
	      }
	    }
	
	    var objApiCall = {};
	    var payloadSuffix = '';
	    if (apiParameters.baseURL == 'use_native') {
	      objApiCall = {
	        method: method,
	        path: pathSuffix + queryString
	      };
	    } else if (apiParameters.baseURL && apiParameters.path) {
	      objApiCall = {
	        method: method,
	        baseURL: apiParameters.baseURL,
	        url: apiParameters.baseURL + apiParameters.path + queryString
	      };
	      payloadSuffix = 'reqJSON=';
	    } else {
	      objApiCall = {
	        method: method,
	        url: this.endPoint + '/' + pathSuffix + queryString
	      };
	    }
	
	    if (apiParameters.payload) {
	      if ((0, _typeof3.default)(apiParameters.payload) === "object") {
	        objApiCall.data = payloadSuffix + (0, _stringify2.default)(apiParameters.payload);
	      } else {
	        objApiCall.data = payloadSuffix + apiParameters.payload;
	      }
	    }
	
	    if (apiParameters.withCredentials) {
	      objApiCall.withCredentials = true;
	    }
	
	    return objApiCall;
	  },
	  httpGet: function httpGet(apiParameters, callback) {
	    this.httpCall('get', apiParameters, callback);
	  },
	  httpPost: function httpPost(apiParameters, callback) {
	    this.httpCall('post', apiParameters, callback);
	  },
	  httpCall: function httpCall(method, apiParameters, callback) {
	    var apiObject = {};
	    if (USE_MOCK_DATA) {
	      var variant = '';
	      if (apiParameters.service == 'getECommItems') {
	        var orderId = apiParameters.queryString['check_num'];
	
	        if (orderId % 2 == 0) {
	          variant = '1';
	        } else {
	          variant = '2';
	        }
	      }
	      var path = 'mock_data/' + apiParameters.service + variant + '.json';
	      this.readFromStatic(path, function (data) {
	        var response = {
	          status: 200,
	          data: data
	        };
	        callback(response);
	      });
	    } else if (this.useOverride) {
	      apiObject = this.apiObject(method, apiParameters);
	      this.directApiCall(apiObject, callback);
	    } else if (this.useProxyApi) {
	      apiObject = this.apiObject(method, apiParameters);
	      this.proxyApiCall(apiObject, callback);
	    } else {
	      apiParameters.baseURL = 'use_native';
	      apiObject = this.apiObject(method, apiParameters);
	      this.nativeCall(apiObject, callback);
	    }
	  },
	  directApiCall: function directApiCall(apiObject, callback) {
	    (0, _axios2.default)(apiObject).then(function (response) {
	      if (response.status !== 200) {
	        console.log('Error - Status Code: ' + response.status);
	        return;
	      }
	
	      if (typeof callback === "function") {
	        callback(response);
	      }
	    }).catch(function (error) {
	      console.log(error);
	
	      if (typeof callback === "function") {
	        callback({ errorMsg: error });
	      }
	    });
	  },
	  proxyApiCall: function proxyApiCall(apiObject, callback) {
	    _axios2.default.defaults.headers.get = {};
	    _axios2.default.defaults.headers.get['x-api-key'] = 'vTr6BdBfqa7DtBj3WRzyQ57r0lFAXRD9a1expX7v';
	
	    (0, _axios2.default)(apiObject).then(function (response) {
	      if (response.status !== 200) {
	        console.log('Error - Status Code: ' + response.status);
	        return;
	      }
	
	      if (typeof callback === "function") {
	        callback(response);
	      }
	    }).catch(function (error) {
	      console.log(error);
	
	      if (typeof callback === "function") {
	        callback({ errorMsg: error });
	      }
	    });
	  },
	  nativeCall: function nativeCall(apiObject, callback) {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var request, response, nativeResponse;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              request = {
	                id: (0, _utils.generateUUID)(),
	                method: apiObject.method.toUpperCase(),
	                url: apiObject.url || '',
	                path: apiObject.path || ''
	              };
	
	
	              if (apiObject.data) {
	                request.body = apiObject.data;
	              }
	
	              response = {
	                data: null,
	                status: 200
	              };
	              nativeResponse = null;
	
	              if (!request.path) {
	                _context.next = 10;
	                break;
	              }
	
	              _context.next = 7;
	              return _this.nativeServerCall(request);
	
	            case 7:
	              nativeResponse = _context.sent;
	              _context.next = 13;
	              break;
	
	            case 10:
	              _context.next = 12;
	              return _this.nativeProxyCall(request);
	
	            case 12:
	              nativeResponse = _context.sent;
	
	            case 13:
	
	              if (!nativeResponse || nativeResponse.error) {
	                response.nativeError = 'connection_error';
	              } else {
	                try {
	                  response.data = JSON.parse(nativeResponse.data);
	                } catch (e) {
	                  response.nativeError = 'no_data';
	                }
	              }
	
	              if (typeof callback === "function") {
	                callback(response);
	              }
	
	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  nativeProxyCall: function nativeProxyCall(request) {
	    var promise = new _promise2.default(function (resolve, reject) {
	      window.promises[request.id] = { resolve: resolve, reject: reject };
	      window.webkit.messageHandlers.network.postMessage(request);
	    });
	
	    return promise;
	  },
	  nativeServerCall: function nativeServerCall(request) {
	    var promise = new _promise2.default(function (resolve, reject) {
	      window.promises[request.id] = { resolve: resolve, reject: reject };
	      window.webkit.messageHandlers.storeServer.postMessage(request);
	    });
	
	    return promise;
	  },
	  initFromConfig: function initFromConfig(config) {
	    if (!config) return false;
	
	    this.setStore(config.storeId);
	    this.setStation(config);
	    this.setLanguage(config);
	    this.setProxy(config);
	
	    return true;
	  },
	  setStore: function setStore(storeNumber) {
	    if (!storeNumber) return false;
	
	    this.storeNumber = parseInt(storeNumber);
	    if (this.storeNumber && this.storeNumber > 0) {
	      this.storeSelected = true;
	
	      this.brand = _brandConfig2.default.getBrandFromStoreNumber(storeNumber);
	      this.appState.orderChannelExclusionList = _brandConfig2.default.orderChannelExclusionList(this.brand);
	      this.appState.orderPanelDisplay = _brandConfig2.default.orderPanelDisplay(this.brand);
	      this.appState.showReadyOverrideList = _brandConfig2.default.showReadyOverrideList();
	    } else {
	      this.storeSelected = false;
	    }
	
	    return this.storeSelected;
	  },
	  setStation: function setStation(config) {
	    if (config.station === 'bin') {
	      this.station = 'bin';
	      if (config.binType === 'grill' || config.binType === 'fry') {
	        this.binType = config.binType;
	      } else {
	        this.binType = 'all';
	      }
	    } else {
	      this.station = 'kds';
	    }
	  },
	  setLanguage: function setLanguage(config) {
	    if (config.language) {
	      console.log('Setting language from system: ' + config.language);
	
	      this.language_flag = 'system';
	      if (config.language.indexOf('fr') >= 0) {
	        this.language = 'FR';
	      } else {
	        this.language = 'EN';
	      }
	    }
	  },
	  setProxy: function setProxy(config) {
	    if (config.useProxy) {
	      this.useProxyApi = true;
	    } else {
	      this.buildEndpoint(config.storeId);
	    }
	  },
	  setEndpoint: function setEndpoint(url) {
	    this.endPoint = url;
	    _axios2.default.defaults.baseURL = url;
	  },
	  buildEndpoint: function buildEndpoint() {
	    console.log('building endpoint: ' + this.storeNumber);
	    if (this.storeNumber) {
	      this.useProxyApi = false;
	      if (this.checkOverride(this.storeNumber)) {
	        this.setEndpoint(this.checkOverride(this.storeNumber));
	        this.useOverride = true;
	      } else {
	        this.setEndpoint('http://h' + this.storeNumber + 'server:90');
	      }
	    }
	  },
	  checkOverride: function checkOverride(storeNumber) {
	    if (ENPOINT_LOOKUP && ENPOINT_LOOKUP['' + storeNumber]) {
	      return ENPOINT_LOOKUP['' + storeNumber];
	    }
	
	    return null;
	  },
	  vmOpenSession: function vmOpenSession(callback) {
	    var _this2 = this;
	
	    console.log('Opening VM session.');
	
	    var apiParameters = {
	      baseURL: VM_API_URL,
	
	      path: '?application=VECOMV1&service=AuthenticationService&command=createSession',
	      payload: { request: {
	          requestHeader: {
	            caller: 'KDS'
	          },
	          requestContent: {
	            '@class': 'createSessionRqstModel',
	            lang: 'EN',
	            version: '1.0.1',
	            appType: 'web'
	          }
	        }
	      }
	    };
	
	    var apiObject = this.apiObject('post', apiParameters);
	
	    (0, _axios2.default)(apiObject).then(function (response) {
	      var success = false;
	
	      if (response.status !== 200) {
	        console.log('Error - Status Code: ' + response.status);
	      } else {
	        if (_this2.apiHelper.checkApiCallSuccess(response)) {
	          var sessionId = _this2.apiHelper.getApiResponseData(response).veSessionID;
	          if (typeof sessionId === 'number') {
	            _this2.vmSessionID = sessionId;
	            success = true;
	          }
	        }
	      }
	
	      if (typeof callback === 'function') callback(success);
	    }).catch(function (error) {
	      console.log(error);
	      if (typeof callback === 'function') callback(false);
	    });
	  },
	  vmPushNotification: function vmPushNotification(vpTicketNumber, callback) {
	    var _this3 = this;
	
	    console.log('VM Push Notification.');
	
	    if (typeof this.vmSessionID !== 'number' || !this.vmSessionID) {
	      this.vmPushNotificationSessionCheck(vpTicketNumber, callback);
	      return;
	    }
	
	    var apiParameters = {
	      baseURL: VM_API_URL,
	
	      path: '?application=VECOMV1&service=OrderService&command=updateOrderSubStatus',
	      payload: { request: {
	          requestHeader: {
	            caller: 'KDS',
	            sessionId: this.vmSessionID
	          },
	          requestContent: {
	            '@class': 'UpdateOrderSubStatusRqstModel',
	            ticketNumber: vpTicketNumber,
	            orderSubStatus: "Dispatched"
	          }
	        }
	      }
	    };
	
	    var apiObject = this.apiObject('post', apiParameters);
	
	    (0, _axios2.default)(apiObject).then(function (response) {
	      var success = false;
	
	      if (response.status !== 200) {
	        console.log('Error - Status Code: ' + response.status);
	        if (typeof callback === 'function') callback(success);
	      } else {
	        if (response.data.response.responseHeader.result == 'Success') {
	          success = true;
	          if (typeof callback === 'function') callback(success);
	        } else {
	          if (response.data && response.data.response && response.data.response.responseHeader && response.data.response.responseHeader.errCode == 'INVALID_SESSION_ID') {
	            _this3.vmPushNotificationSessionCheck(vpTicketNumber, callback);
	          } else {
	            if (typeof callback === 'function') callback(response);
	          }
	        }
	      }
	    }).catch(function (error) {
	      console.log(error);
	      if (typeof callback === 'function') callback(response);
	    });
	  },
	  vmPushNotificationSessionCheck: function vmPushNotificationSessionCheck(vpTicketNumber, callback) {
	    var _this4 = this;
	
	    this.sessionRetryCount++;
	
	    if (this.sessionRetryCount > 5) {
	      this.sessionRetryCount = 0;
	      console.log('Failed to open VM session');
	      if (typeof callback === 'function') callback(false);
	    } else {
	      if (this.vmSessionID) {
	        setTimeout(function () {
	          _this4.vmPushNotification(vpTicketNumber, callback);
	        }, 5000);
	      } else {
	        this.vmOpenSession(function (success) {
	          if (success) {
	            _this4.vmPushNotification(vpTicketNumber, callback);
	          } else {
	            _this4.vmPushNotificationSessionCheck(vpTicketNumber, callback);
	          }
	        });
	      }
	    }
	  },
	  jarvisBinManagement: function jarvisBinManagement(storeId, businessDate, callback) {
	    console.log('Jarvis Bin Management call.');
	
	    _axios2.default.defaults.headers.get = {};
	    _axios2.default.defaults.headers.get['authorization'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJLRFMifQ.JGb6IC4HBb4u8OpE3h3MEwiwFtaN6Qglu8txs4yHO2k';
	
	    var apiParameters = {
	      baseURL: JARVIS_API_URL,
	      path: '/kds/bin/store/' + storeId,
	      queryString: {
	        'businessDate': businessDate,
	        'prepLocation': this.binType
	      }
	    };
	
	    var apiObject = this.apiObject('get', apiParameters);
	
	    (0, _axios2.default)(apiObject).then(function (response) {
	      var success = false;
	
	      if (response.status !== 200) {
	        console.log('Error - Status Code: ' + response.status);
	        if (typeof callback === 'function') callback(success);
	      } else {
	        if (response.data) {
	          if (typeof callback === 'function') callback(response.data);
	        } else {}
	      }
	    }).catch(function (error) {
	      console.log(error);
	      if (typeof callback === 'function') callback(error);
	    });
	  },
	  readFromStatic: function readFromStatic(path, callback) {
	    var baseURL = location.protocol + '//' + location.hostname;
	    if (location.port) baseURL += ':' + location.port;
	
	    var objApiCall = {
	      method: 'get',
	      baseURL: baseURL,
	      url: baseURL + '/static/' + path
	    };
	
	    (0, _axios2.default)(objApiCall).then(function (response) {
	      if (typeof callback === 'function') callback(response.data);
	    }).catch(function (error) {
	      if (typeof callback === 'function') callback(null);
	    });
	  },
	  getState: function getState() {
	    var savedState = _appState2.default.getStateCookie();
	
	    if (savedState) {
	      this.appState = savedState;
	
	      this.mainAPIServer = this.appState.mainAPIServer || PROXY_API_URL;
	      this.endPoint = this.appState.endPoint || PROXY_API_URL;
	      this.storeSelected = this.appState.storeSelected || false;
	      this.storeNumber = this.appState.storeNumber;
	      this.kdsDetailView = this.appState.kdsDetailView;
	    }
	  },
	  saveState: function saveState() {
	    console.log('state saved');
	    this.appState.mainAPIServer = this.mainAPIServer;
	    this.appState.endPoint = this.endPoint;
	    this.appState.storeSelected = this.storeSelected;
	    this.appState.storeNumber = this.storeNumber;
	    this.appState.kdsDetailView = this.kdsDetailView;
	
	    _appState2.default.saveStateCookie(this.appState);
	  },
	  getStateObject: function getStateObject() {
	    console.log('state loaded');
	    return this.appState;
	  },
	
	
	  apiHelper: {
	    checkApiCallSuccess: function checkApiCallSuccess(response) {
	      if (!response) return false;
	      if (!response.data) return false;
	      if (!response.data.response) return false;
	      if (!response.data.response.responseContent) return false;
	      if (response.data.response.responseContent.status && response.data.response.responseContent.status.toLowerCase() === "success") return true;
	      if (response.data.response.responseContent.businessStatusModel && response.data.response.responseContent.businessStatusModel.status && response.data.response.responseContent.businessStatusModel.status.toLowerCase() === "success") return true;
	
	      return false;
	    },
	
	    getApiResponseData: function getApiResponseData(response) {
	      if (!response) return {};
	      if (!response.data) return {};
	      if (!response.data.response) return {};
	      if (!response.data.response.responseContent) return {};
	
	      return response.data.response.responseContent;
	    },
	
	    getApiCallError: function getApiCallError(response) {
	      var errMsg = response.data || response;
	
	      if (!response) return errMsg;
	      if (!response.data) return errMsg;
	      if (!response.data.response) return errMsg;
	      if (!response.data.response.responseContent) return errMsg;
	      if (response.data.response.responseContent.businessStatusModel && response.data.response.responseContent.businessStatusModel.screenMsg) {
	        errMsg = response.data.response.responseContent.businessStatusModel.screenMsg;
	      }
	      if (response.data.response.responseContent.screenMsg) {
	        errMsg = response.data.response.responseContent.screenMsg;
	      }
	
	      return errMsg;
	    }
	
	  }
	};

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(206);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(546);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Main = __webpack_require__(516);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _KdsDisplay = __webpack_require__(514);
	
	var _KdsDisplay2 = _interopRequireDefault(_KdsDisplay);
	
	var _RecallDisplay = __webpack_require__(517);
	
	var _RecallDisplay2 = _interopRequireDefault(_RecallDisplay);
	
	var _Login = __webpack_require__(515);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _BinManager = __webpack_require__(511);
	
	var _BinManager2 = _interopRequireDefault(_BinManager);
	
	var _InfoDisplay = __webpack_require__(513);
	
	var _InfoDisplay2 = _interopRequireDefault(_InfoDisplay);
	
	var _GuestFacingBoard = __webpack_require__(512);
	
	var _GuestFacingBoard2 = _interopRequireDefault(_GuestFacingBoard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
	  routes: [{ path: '/main', meta: { title: 'KDS - Main' }, component: _Main2.default }, { path: '/kdsPrep', meta: { title: 'KDS - Preparing' }, component: _KdsDisplay2.default, props: { readyOrdersDisplay: false } }, { path: '/kdsReady', meta: { title: 'KDS - Ready for Pickup' }, component: _KdsDisplay2.default, props: { readyOrdersDisplay: true } }, { path: '/recall', meta: { title: 'KDS - Recall' }, component: _RecallDisplay2.default }, { path: '/login', meta: { title: 'KDS - Login' }, component: _Login2.default }, { path: '/kdsBin', meta: { title: 'KDS - Bin Manager' }, component: _BinManager2.default }, { path: '/info', meta: { title: 'KDS - Info' }, component: _InfoDisplay2.default }, { path: '/gfb', meta: { title: 'Guest Facing Board' }, component: _GuestFacingBoard2.default }, { path: '/gfb/:storeID', meta: { title: 'Guest Facing Board' }, component: _GuestFacingBoard2.default }, { path: '*', redirect: '/main' }]
	});

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formatting = __webpack_require__(62);
	
	var _formatting2 = _interopRequireDefault(_formatting);
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    dateFormat: {
	
	        timeHMampm: function timeHMampm(dtValue) {
	            var hours, minutes;
	
	            if (dtValue instanceof Date) {
	                hours = dtValue.getHours();
	                minutes = dtValue.getMinutes();
	            } else if (typeof dtValue === 'string') {
	                var aTime = dtValue.split(':');
	                if (aTime.length != 2) return null;
	
	                hours = parseInt(aTime[0]);
	                minutes = parseInt(aTime[1]);
	            } else {
	                return null;
	            }
	
	            var ampm = hours >= 12 ? 'PM' : 'AM';
	            hours = hours % 12;
	            hours = hours ? hours : 12;
	            minutes = minutes < 10 ? '0' + minutes : minutes;
	            var strTime = hours + ':' + minutes + ' ' + ampm;
	            return strTime;
	        },
	
	        timeHM24: function timeHM24(a1, a2) {
	
	            var h = 0;
	            var m = 0;
	
	            if (a1 instanceof Date) {
	                h = a1.getHours();
	                m = a1.getMinutes();
	            } else if (typeof a1 === 'string' && !a2) {
	                var aTime = a1.split(':');
	                if (aTime.length != 2) return null;
	
	                h = parseInt(aTime[0]);
	                m = parseInt(aTime[1]);
	            } else if (typeof a1 != 'undefined' && typeof a2 != 'undefined') {
	                h = a1;
	                m = a2;
	            } else {
	                return null;
	            }
	
	            return _formatting2.default.numberFormat.pad(h, 2) + ':' + _formatting2.default.numberFormat.pad(m, 2);
	        },
	
	        dateFromStr: function dateFromStr(s) {
	            if (!s) return null;
	            var aDate = s.split(/[^0-9]/);
	            var newDate;
	            if (aDate[3] && aDate[4] && aDate[5]) {
	                newDate = new Date(aDate[0], aDate[1] - 1, aDate[2], aDate[3], aDate[4], aDate[5]);
	            } else if (aDate[3] && aDate[4]) {
	                newDate = new Date(aDate[0], aDate[1] - 1, aDate[2], aDate[3], aDate[4]);
	            } else {
	                newDate = new Date(aDate[0], aDate[1] - 1, aDate[2]);
	            }
	            return newDate;
	        },
	        calcElapsedTime: function calcElapsedTime(startTime, currentTime) {
	            var endTime = currentTime || new Date();
	
	            var timeDiff = endTime - startTime;
	
	            timeDiff /= 1000;
	            var seconds = Math.round(timeDiff % 60);
	
	            timeDiff = Math.floor(timeDiff / 60);
	            var minutes = Math.round(timeDiff % 60);
	
	            var displayColour = '#FF0000';
	            if (timeDiff < 10) {
	                displayColour = '#008000';
	            } else if (timeDiff < 20) {
	                displayColour = '#00008b';
	            }
	
	            var totalMinutes = timeDiff;
	
	            timeDiff = Math.floor(timeDiff / 60);
	            var hours = Math.round(timeDiff % 24);
	
	            timeDiff = Math.floor(timeDiff / 24);
	
	            var days = timeDiff;
	
	            var sDays = days ? days + 'D ' : '';
	
	            var sHours = hours ? hours + ':' : '';
	
	            var sMinutes = hours ? _formatting2.default.numberFormat.pad(minutes) : minutes;
	
	            return {
	                time: sDays + sHours + sMinutes + ':' + _formatting2.default.numberFormat.pad(seconds),
	                totalMinutes: totalMinutes,
	                colour: displayColour
	            };
	        },
	        calcDiffInMinutes: function calcDiffInMinutes(dt2, dt1) {
	            var diff = (dt2.getTime() - dt1.getTime()) / 1000;
	            diff /= 60;
	            return Math.abs(Math.round(diff));
	        }
	    },
	
	    numberFormat: {
	        pad: function pad(n, width, z) {
	            z = z || '0';
	            n = n + '';
	            width = width || 2;
	            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	        },
	        roundTo2Dec: function roundTo2Dec(num) {
	            return Math.round(num * 100) / 100;
	        }
	    },
	
	    stringFormat: {
	        capitalize: function capitalize(str) {
	
	            if (!str) return str;
	
	            var aStr = ('' + str).split(' ');
	            var sCapitalized = '';
	
	            for (var s = 0; s < aStr.length; s++) {
	                if (sCapitalized) {
	                    sCapitalized += ' ';
	                }
	                sCapitalized += aStr[s].charAt(0).toUpperCase() + aStr[s].slice(1).toLowerCase();
	            }
	
	            return sCapitalized;
	        },
	        truncateWithEllipsis: function truncateWithEllipsis(str, n) {
	            return str.length > n ? str.substr(0, n - 1) + '...' : str;
	        }
	    }
	
	};

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getQueryStringParameterByName = getQueryStringParameterByName;
	exports.getQueryStringParameterByNameRaw = getQueryStringParameterByNameRaw;
	exports.selectByLabel = selectByLabel;
	exports.selectByVal = selectByVal;
	exports.generateUUID = generateUUID;
	exports.getRandomInt = getRandomInt;
	exports.arrRemoveBlanks = arrRemoveBlanks;
	exports.testConnection = testConnection;
	exports.idFullStory = idFullStory;
	exports.checkFilterCriteria = checkFilterCriteria;
	function getQueryStringParameterByName(name, url) {
	  if (!url) {
	    url = window.location.href;
	  }
	  name = name.replace(/[\[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	      results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	function getQueryStringParameterByNameRaw(name, url) {
	  if (!url) {
	    url = window.location.href;
	  }
	  name = name.replace(/[\[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	      results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return results[2];
	}
	
	function selectByLabel(checkLabel, dataList) {
	
	  for (var i = 0; i < dataList.length; i++) {
	    if (dataList[i].label == checkLabel) {
	      return dataList[i].val;
	    }
	  }
	
	  return null;
	}
	
	function selectByVal(checkVal, dataList) {
	
	  for (var i = 0; i < dataList.length; i++) {
	    if (dataList[i].val == checkVal) {
	      return dataList[i].label;
	    }
	  }
	
	  return null;
	}
	
	function generateUUID() {
	  var d = new Date().getTime();
	  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = (d + Math.random() * 16) % 16 | 0;
	    d = Math.floor(d / 16);
	    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	  });
	  return uuid;
	}
	
	function getRandomInt(min, max) {
	
	  return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	function arrRemoveBlanks(a) {
	  if (!a.length) return [];
	
	  for (var i = a.length - 1; i >= 0; i--) {
	    if (!a[i]) {
	      a.splice(i, 1);
	    }
	  }
	  return a;
	}
	
	function testConnection() {
	  var xhr = new XMLHttpRequest();
	
	  xhr.open('HEAD', '/', false);
	  try {
	    xhr.send();
	    onLine = true;
	  } catch (e) {
	    onLine = false;
	  }
	
	  return onLine;
	}
	
	function idFullStory(storeId) {
	  try {
	    if (typeof FS != "undefined") {
	      if (FS.identify) {
	        console.log('set Full Story Id');
	
	        if (storeId) {
	          FS.identify(storeId, { email: '' + storeId });
	        }
	      }
	    }
	  } catch (e) {}
	}
	
	function checkFilterCriteria(criteria, data) {
	
	  if (!criteria || !data) {
	    return false;
	  }
	
	  if (criteria == '*') {
	    return true;
	  }
	
	  if (criteria == data) {
	    return true;
	  }
	
	  if (criteria && criteria.substring(0, 1) == '!') {
	    var check = criteria.substring(1);
	    if (check != data) {
	      return true;
	    }
	  }
	
	  return false;
	}

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SWISS = 'swiss';
	var HARVEYS = 'harveys';
	
	exports.default = {
	    brandDefault: HARVEYS,
	
	    getBrandFromStoreNumber: function getBrandFromStoreNumber(storeNumber) {
	
	        var firstChar = ("" + storeNumber).substring(0, 1);
	
	        if (firstChar == '1') {
	            return SWISS;
	        } else if (firstChar == '2') {
	            return HARVEYS;
	        } else {
	            return this.brandDefault;
	        }
	    },
	    orderChannelExclusionList: function orderChannelExclusionList(brand) {
	        if (!brand) {
	            brand = this.brandDefault;
	        }
	
	        if (brand == SWISS) {
	            return [{ "channel": "Call Center", "type": "Delivery" }, { "channel": "UberEats", "type": "*" }, { "channel": "Skip The Dish", "type": "*" }, { "channel": "Door Dash", "type": "*" }, { "emp_num": "21000", "type": "Pick Up" }];
	        } else if (brand == HARVEYS) {
	            return [{ "channel": "Harv Call Center", "type": "Delivery" }, { "channel": "Call Center", "type": "Delivery" }, { "channel": "*", "type": "Take Out" }, { "emp_num": "20999", "type": "Pick Up" }];
	        } else {
	            return [];
	        }
	    },
	    orderPanelDisplay: function orderPanelDisplay(brand) {
	        if (!brand) {
	            brand = this.brandDefault;
	        }
	
	        if (brand == HARVEYS) {
	            return {
	                left: [{ "channel": "Harv Call Center", "type": "*" }, { "channel": "Call Center", "type": "*" }],
	                right: [{ "channel": "UberEats", "type": "*" }, { "channel": "Skip The Dish", "type": "*" }, { "channel": "Door Dash", "type": "*" }]
	            };
	        } else {
	            return null;
	        }
	    },
	    showReadyOverrideList: function showReadyOverrideList() {
	        return ["2314", "2784", "2781", "2778"];
	    },
	    aggregatorNameRemap: function aggregatorNameRemap(name) {
	        if (!name) return '';
	
	        var test = ('' + name).toLowerCase();
	
	        if (test.indexOf('uber') >= 0) {
	            return 'Uber Eats';
	        } else if (test.indexOf('skip') >= 0) {
	            return 'Skip the Dishes';
	        } else if (test.indexOf('dash') >= 0) {
	            return 'DoorDash';
	        } else {
	            return name;
	        }
	    }
	};

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(231)
	
	/* template */
	var __vue_template__ = __webpack_require__(527)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(499)
	
	/* script */
	__vue_exports__ = __webpack_require__(232)
	
	/* template */
	var __vue_template__ = __webpack_require__(531)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66ff117f"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(95);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _iterator = __webpack_require__(149);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _getOwnPropertyNames = __webpack_require__(245);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _classCallCheck2 = __webpack_require__(248);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(249);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(241);
	
	var ArrayProto = Array.prototype;
	var nodeError = new Error('Passed arguments must be of Node');
	var blurEvent;
	var blurList = [];
	var Events = [];
	var NodeListJS = function NodeListJS() {
	  if (typeof window !== 'undefined') {
	    var isNode = function isNode(val) {
	      return val instanceof window.Node;
	    };
	
	    var isNodeList = function isNodeList(val) {
	      return val instanceof window.NodeList || val instanceof NodeList || val instanceof window.HTMLCollection || val instanceof Array;
	    };
	
	    var flatten = function flatten(arr, owner) {
	      var list = [];
	      ArrayProto.forEach.call(arr, function (el) {
	        if (isNode(el)) {
	          if (!~list.indexOf(el)) list.push(el);
	        } else if (isNodeList(el)) {
	          for (var id in el) {
	            if (!~list.indexOf(el[id])) list.push(el[id]);
	          }
	        } else if (el !== null) {
	          arr.get = NL.get;
	          arr.set = NL.set;
	          arr.call = NL.call;
	          arr.owner = owner;
	          return arr;
	        }
	      });
	      return _NodeListJS(list, owner);
	    };
	
	    var setterGetter = function setterGetter(prop) {
	      var _this3 = this;
	
	      if (NL[prop]) return;
	      if (div[prop] instanceof Function) {
	        NL[prop] = function () {
	          for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
	            args[_key11] = arguments[_key11];
	          }
	
	          var arr = [];
	          var returnThis = true;
	          for (var i in NL) {
	            var el = NL[i];
	            if (el && el[prop] instanceof Function) {
	              el = el[prop].apply(el, args);
	              arr.push(el);
	              if (returnThis && el !== undefined) {
	                returnThis = false;
	              }
	            } else {
	              arr.push(undefined);
	            }
	          }
	          return returnThis ? _this3 : flatten(arr, _this3);
	        };
	      } else {
	        (0, _defineProperty2.default)(NL, prop, {
	          get: function get() {
	            var arr = [];
	            this.each(function (el) {
	              if (el !== null) {
	                el = el[prop];
	              }
	              arr.push(el);
	            });
	            return flatten(arr, this);
	          },
	          set: function set(value) {
	            this.each(function (el) {
	              if (el && prop in el) {
	                el[prop] = value;
	              }
	            });
	          }
	        });
	      }
	    };
	
	    var _NodeListJS = function _NodeListJS() {
	      for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
	        args[_key12] = arguments[_key12];
	      }
	
	      return new NodeList(args);
	    };
	
	    var NodeList = function () {
	      function NodeList(args) {
	        (0, _classCallCheck3.default)(this, NodeList);
	
	        var nodes = args;
	        if (args[0] === window) {
	          nodes = [window];
	        } else if (typeof args[0] === 'string') {
	          nodes = (args[1] || document).querySelectorAll(args[0]);
	          if (args[1]) {
	            this.owner = args[1];
	          }
	        } else if (0 in args && !isNode(args[0]) && args[0] && 'length' in args[0]) {
	          nodes = args[0];
	          if (args[1]) {
	            this.owner = args[1];
	          }
	        }
	        if (nodes) {
	          for (var i in nodes) {
	            this[i] = nodes[i];
	          }
	          this.length = nodes.length;
	        } else {
	          this.length = 0;
	        }
	        window.prueba = this;
	      }
	
	      (0, _createClass3.default)(NodeList, [{
	        key: 'concat',
	        value: function concat() {
	          var nodes = ArrayProto.slice.call(this);
	          function flatten(arr) {
	            ArrayProto.forEach.call(arr, function (el) {
	              if (isNode(el)) {
	                if (!~nodes.indexOf(el)) nodes.push(el);
	              } else if (isNodeList(el)) {
	                flatten(el);
	              }
	            });
	          }
	
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          ArrayProto.forEach.call(args, function (arg) {
	            if (isNode(arg)) {
	              if (!~nodes.indexOf(arg)) nodes.push(arg);
	            } else if (isNodeList(arg)) {
	              flatten(arg);
	            } else {
	              throw Error('Concat arguments must be of a Node, NodeList, HTMLCollection, or Array of (Node, NodeList, HTMLCollection, Array)');
	            }
	          });
	          return _NodeListJS(nodes, this);
	        }
	      }, {
	        key: 'delete',
	        value: function _delete() {
	          var notRemoved = flatten(this).filter(function (el) {
	            if (el.remove) {
	              el.remove();
	            } else if (el.parentNode) {
	              el.parentNode.removeChild(el);
	            }
	            return document.body.contains(el);
	          });
	          if (notRemoved.length) console.warn('NodeList: Some nodes could not be deleted.');
	          return notRemoved;
	        }
	      }, {
	        key: 'each',
	        value: function each() {
	          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          ArrayProto.forEach.apply(this, args);
	          return this;
	        }
	      }, {
	        key: 'filter',
	        value: function filter() {
	          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	          }
	
	          return _NodeListJS(ArrayProto.filter.apply(this, args), this);
	        }
	      }, {
	        key: 'find',
	        value: function find(element) {
	          var nodes = [];
	          if (typeof element === 'string') flatten(this).forEach(function (node) {
	            nodes.push(node.querySelectorAll(element));
	          });
	          if (isNode(element)) flatten(this).forEach(function (node) {
	            if (node !== element && node.contains(element)) nodes.push(element);
	          });
	          if (isNodeList(element)) {
	            var els = flatten(element);
	            flatten(this).forEach(function (node) {
	              els.forEach(function (el) {
	                if (node !== el && node.contains(el)) nodes.push(el);
	              });
	            });
	          }
	          return flatten(nodes, this.owner);
	        }
	      }, {
	        key: 'forEach',
	        value: function forEach() {
	          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	          }
	
	          ArrayProto.forEach.apply(this, args);
	          return this;
	        }
	      }, {
	        key: 'includes',
	        value: function includes(element, index) {
	          return ~this.indexOf(element, index);
	        }
	      }, {
	        key: 'map',
	        value: function map() {
	          for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	            args[_key5] = arguments[_key5];
	          }
	
	          var mapped = ArrayProto.map.apply(this, args);
	          return mapped.some(function (el) {
	            return isNode(el) || isNodeList(el);
	          }) ? flatten(mapped, this) : mapped;
	        }
	      }, {
	        key: 'parent',
	        value: function parent() {
	          return flatten(this.map(function (el) {
	            return el.parentNode;
	          }), this);
	        }
	      }, {
	        key: 'pop',
	        value: function pop(amount) {
	          if (typeof amount !== 'number') {
	            amount = 1;
	          }
	          var nodes = [];
	          var pop = ArrayProto.pop.bind(this);
	          while (amount--) {
	            nodes.push(pop());
	          }return _NodeListJS(nodes, this);
	        }
	      }, {
	        key: 'push',
	        value: function push() {
	          var _this = this;
	
	          for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	            args[_key6] = arguments[_key6];
	          }
	
	          ArrayProto.forEach.call(args, function (arg) {
	            if (!isNode(arg)) throw nodeError;
	            if (!~_this.indexOf(arg)) ArrayProto.push.call(_this, arg);
	          });
	          return this;
	        }
	      }, {
	        key: 'shift',
	        value: function shift(amount) {
	          if (typeof amount !== 'number') {
	            amount = 1;
	          }
	          var nodes = [];
	          while (amount--) {
	            nodes.push(ArrayProto.shift.call(this));
	          }return nodes.length == 1 ? nodes[0] : _NodeListJS(nodes, this);
	        }
	      }, {
	        key: 'slice',
	        value: function slice() {
	          for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	            args[_key7] = arguments[_key7];
	          }
	
	          return _NodeListJS(ArrayProto.slice.apply(this, args), this);
	        }
	      }, {
	        key: 'splice',
	        value: function splice() {
	          for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	            args[_key8] = arguments[_key8];
	          }
	
	          for (var i = 2, l = args.length; i < l; i++) {
	            if (!isNode(args[i])) throw nodeError;
	          }
	          ArrayProto.splice.apply(this, args);
	          return this;
	        }
	      }, {
	        key: 'unshift',
	        value: function unshift() {
	          var _this2 = this;
	
	          var unshift = ArrayProto.unshift.bind(this);
	
	          for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
	            args[_key9] = arguments[_key9];
	          }
	
	          ArrayProto.forEach.call(args, function (arg) {
	            if (!isNode(arg)) throw nodeError;
	            if (!~_this2.indexOf(arg)) unshift(arg);
	          });
	          return this;
	        }
	      }, {
	        key: 'addClass',
	        value: function addClass(classes) {
	          return this.toggleClass(classes, true);
	        }
	      }, {
	        key: 'removeClass',
	        value: function removeClass(classes) {
	          return this.toggleClass(classes, false);
	        }
	      }, {
	        key: 'toggleClass',
	        value: function toggleClass(classes) {
	          var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	          var method = value === undefined || value === null ? 'toggle' : value ? 'add' : 'remove';
	          if (typeof classes === 'string') {
	            classes = classes.trim().replace(/\s+/, ' ').split(' ');
	          }
	          return this.each(function (el) {
	            return classes.forEach(function (c) {
	              return el.classList[method](c);
	            });
	          });
	        }
	      }, {
	        key: 'get',
	        value: function get(prop) {
	          var arr = [];
	          this.each(function (el) {
	            if (el !== null) {
	              el = el[prop];
	            }
	            arr.push(el);
	          });
	          return flatten(arr, this);
	        }
	      }, {
	        key: 'set',
	        value: function set(prop, value) {
	          if (prop.constructor === Object) {
	            this.each(function (el) {
	              if (el) {
	                for (var key in prop) {
	                  if (key in el) {
	                    el[key] = prop[key];
	                  }
	                }
	              }
	            });
	          } else {
	            this.each(function (el) {
	              if (prop in el) {
	                el[prop] = value;
	              }
	            });
	          }
	          return this;
	        }
	      }, {
	        key: 'call',
	        value: function call() {
	          for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
	            args[_key10] = arguments[_key10];
	          }
	
	          var method = ArrayProto.shift.call(args);
	          var arr = [];
	          var returnThis = true;
	          this.each(function (el) {
	            if (el && el[method] instanceof Function) {
	              el = el[method].apply(el, args);
	              arr.push(el);
	              if (returnThis && el !== undefined) {
	                returnThis = false;
	              }
	            } else {
	              arr.push(undefined);
	            }
	          });
	          return returnThis ? this : flatten(arr, this);
	        }
	      }, {
	        key: 'item',
	        value: function item(index) {
	          return _NodeListJS([this[index]], this);
	        }
	      }, {
	        key: 'on',
	        value: function on(events, selector, callback) {
	          if (typeof events === 'string') {
	            events = events.trim().replace(/\s+/, ' ').split(' ');
	          }
	          if (!this || !this.length) return this;
	          if (callback === undefined) {
	            callback = selector;
	            selector = null;
	          }
	          if (!callback) return this;
	          var fn = callback;
	          callback = selector ? function (e) {
	            var els = _NodeListJS(selector, this);
	            if (!els.length) {
	              return;
	            }
	            els.some(function (el) {
	              var target = el.contains(e.target);
	              if (target) fn.call(el, e, el);
	              return target;
	            });
	          } : function (e) {
	            fn.apply(this, [e, this]);
	          };
	          this.each(function (el) {
	            events.forEach(function (event) {
	              if (el === window || isNode(el)) {
	                el.addEventListener(event, callback, false);
	                Events.push({
	                  el: el,
	                  event: event,
	                  callback: callback
	                });
	              }
	            });
	          });
	          return this;
	        }
	      }, {
	        key: 'off',
	        value: function off(events, callback) {
	          if (events instanceof Function) {
	            callback = events;
	            events = null;
	          }
	          events = events instanceof Array ? events : typeof events === 'string' ? events.trim().replace(/\s+/, ' ').split(' ') : null;
	          this.each(function (el) {
	            Events = Events.filter(function (e) {
	              if (e && e.el === el && (!callback || callback === e.callback) && (!events || ~events.indexOf(e.event))) {
	                e.el.removeEventListener(e.event, e.callback);
	                return false;
	              }
	              return true;
	            });
	          });
	          return this;
	        }
	      }, {
	        key: 'onBlur',
	        value: function onBlur(callback) {
	          if (!this || !this.length) return this;
	          if (!callback) return this;
	          this.each(function (el) {
	            blurList.push({ el: el, callback: callback });
	          });
	          if (!blurEvent) {
	            blurEvent = function blurEvent(e) {
	              blurList.forEach(function (item) {
	                var target = item.el.contains(e.target) || item.el === e.target;
	                if (!target) item.callback.call(item.el, e, item.el);
	              });
	            };
	            document.addEventListener('click', blurEvent, false);
	            document.addEventListener('touchstart', blurEvent, false);
	          }
	          return this;
	        }
	      }, {
	        key: 'offBlur',
	        value: function offBlur(callback) {
	          this.each(function (el) {
	            blurList = blurList.filter(function (blur) {
	              if (blur && blur.el === el && (!callback || blur.callback === callback)) {
	                return false;
	              }
	              return el;
	            });
	          });
	          return this;
	        }
	      }, {
	        key: 'asArray',
	        get: function get() {
	          return ArrayProto.slice.call(this);
	        }
	      }]);
	      return NodeList;
	    }();
	
	    var NL = NodeList.prototype;
	
	    var exceptions = ['join', 'copyWithin', 'fill', 'find', 'forEach'];
	    (0, _getOwnPropertyNames2.default)(ArrayProto).forEach(function (key) {
	      if (!~exceptions.indexOf(key) && NL[key] === undefined) {
	        NL[key] = ArrayProto[key];
	      }
	    });
	    if (typeof window !== 'undefined' && window.Symbol && _iterator2.default) {
	      NL[_iterator2.default] = NL.values = ArrayProto[_iterator2.default];
	    }
	    var div = document.createElement('div');
	
	    for (var prop in div) {
	      setterGetter(prop);
	    }
	    window.NL = _NodeListJS;
	    return _NodeListJS;
	  }
	};
	
	exports.default = NodeListJS();

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _brandConfig = __webpack_require__(93);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _Navbar = __webpack_require__(519);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Dropdown = __webpack_require__(518);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Spinner = __webpack_require__(521);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'navbar': _Navbar2.default,
	    'dropdown': _Dropdown2.default,
	    'spinner': _Spinner2.default
	
	  },
	
	  methods: {
	    getChannelExclusionList: function getChannelExclusionList() {},
	    clickSoundPlay: function clickSoundPlay() {
	      if (this.clickSound) {
	        this.clickSound.play();
	      }
	    },
	    orderSoundPlay: function orderSoundPlay() {
	      if (this.orderSound) {
	        this.orderSound.play();
	      }
	    },
	    bumpSoundPlay: function bumpSoundPlay() {
	      if (this.bumpSound) {
	        this.bumpSound.play();
	      }
	    },
	    logout: function logout() {
	      _apiBridge2.default.logout();
	
	      this.appState = _apiBridge2.default.appState;
	    }
	  },
	
	  data: function data() {
	    return {
	      appState: _apiBridge2.default.appState
	    };
	  },
	
	
	  mounted: function mounted() {
	    console.log('app container page loaded');
	
	    this.getChannelExclusionList();
	
	    this.clickSound = document.getElementById('clickSound');
	    this.orderSound = document.getElementById('orderSound');
	    this.bumpSound = document.getElementById('bumpSound');
	  }
	
	};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _formatting = __webpack_require__(62);
	
	var _formatting2 = _interopRequireDefault(_formatting);
	
	var _dateformat = __webpack_require__(495);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueAwesomeSwiper = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    name: 'bin',
	
	    components: {
	        'swiper': _vueAwesomeSwiper.swiper,
	        'swiper-slide': _vueAwesomeSwiper.swiperSlide
	    },
	
	    created: function created() {},
	
	    methods: {
	        getTimeBrackets: function getTimeBrackets() {
	            console.log('Get time brackets');
	
	            var self = this;
	            _apiBridge2.default.jarvisBinManagement(_apiBridge2.default.storeNumber, (0, _dateformat2.default)(new Date(), 'yyyy-mm-dd'), function (response) {
	                self.timeBrackets = response.data;
	                self.updateCurrentBracket();
	
	                self.$forceUpdate();
	            });
	        },
	        updateCurrentBracket: function updateCurrentBracket() {
	            this.currentBracket = null;
	
	            this.currentTime = new Date();
	
	            if (this.currentTime && this.timeBrackets && this.timeBrackets.length) {
	                var fromTime = void 0,
	                    toTime = void 0;
	                for (var t = 0; t < this.timeBrackets.length; t++) {
	                    fromTime = _formatting2.default.dateFormat.dateFromStr(this.timeBrackets[t].from + ':00');
	                    toTime = _formatting2.default.dateFormat.dateFromStr(this.timeBrackets[t].to + ':00');
	
	                    if (this.currentTime >= fromTime && this.currentTime < toTime) {
	                        this.currentBracket = this.timeBrackets[t];
	
	                        var prevBracket = t == 0 ? null : this.timeBrackets[t - 1];
	
	                        var nextBracket = t == this.timeBrackets.length - 1 ? null : this.timeBrackets[t + 1];
	
	                        this.processBinData(this.currentBracket.supplies, prevBracket, nextBracket);
	
	                        this.currentBracket.fromTime = this.currentBracket.from.split('T')[1].replace('.000Z', '');
	                        this.currentBracket.toTime = this.currentBracket.to.split('T')[1].replace('.000Z', '');
	
	                        break;
	                    }
	                }
	            }
	        },
	        processBinData: function processBinData(binList, prevBracket, nextBracket) {
	            this.binList = binList || this.currentBracket.supplies;
	
	            for (var b = 0; b < this.binList.length; b++) {
	
	                this.binList[b].prevQty = '';
	                this.binList[b].nextQty = '';
	
	                if (prevBracket && prevBracket.supplies) {
	                    for (var p = 0; p < prevBracket.supplies.length; p++) {
	                        if (this.binList[b].id == prevBracket.supplies[p].id) {
	                            this.binList[b].prevQty = prevBracket.supplies[p].qty;
	                        }
	                    }
	                }
	
	                if (nextBracket && nextBracket.supplies) {
	                    for (var n = 0; n < nextBracket.supplies.length; n++) {
	                        if (this.binList[b].id == nextBracket.supplies[n].id) {
	                            this.binList[b].nextQty = nextBracket.supplies[n].qty;
	                        }
	                    }
	                }
	            }
	        },
	        updateElapsedTime: function updateElapsedTime() {
	            if (this.currentTime) {
	                this.currentTime.setSeconds(this.currentTime.getSeconds() + 1);
	
	                if (this.currentTime.getHours() == 4 && this.currentTime.getMinutes() == 30 && this.currentTime.getSeconds() == 0) {
	                    this.init();
	                }
	
	                if (this.currentBracket) {
	                    var toTime = _formatting2.default.dateFormat.dateFromStr(this.currentBracket.to);
	                    this.elapsedTime = _formatting2.default.dateFormat.calcElapsedTime(this.currentTime, toTime).time;
	
	                    if (this.elapsedTime == '0:00' || this.elapsedTime.indexOf('-1D') >= 0) {
	                        this.remainingLabel = this.LOADING + '...';
	                        this.elapsedTime = '';
	
	                        this.updateCurrentBracket();
	                    } else {
	                        this.remainingLabel = this.REMAINING + ':';
	                    }
	                } else {
	                    this.updateCurrentBracket();
	                }
	            }
	        },
	        gotoMain: function gotoMain() {
	            _router2.default.push('/main');
	        },
	        reload: function reload() {
	            location.reload(true);
	        },
	        gotoInfo: function gotoInfo() {
	            _router2.default.push('/info');
	        },
	        init: function init() {
	            var _this = this;
	
	            if (!_apiBridge2.default.storeSelected) {
	                _router2.default.push('/login');
	            }
	
	            this.remainingLabel = this.$t('loading') + '...';
	            this.elapsedTime = '';
	
	            this.currentTime = new Date();
	            this.getTimeBrackets();
	
	            if (this.uiInterval) clearInterval(this.uiInterval);
	            this.uiInterval = setInterval(function () {
	                _this.updateElapsedTime();
	            }, 1000);
	
	            setTimeout(function () {
	                _this.logoutTimeout = false;
	            }, 2000);
	        }
	    },
	
	    mounted: function mounted() {
	        console.log('Bin Management page');
	        document.body.style.backgroundColor = "#000";
	
	        this.LOADING = this.$t('loading');
	        this.REMAINING = this.$t('remaining');
	
	        this.init();
	    },
	
	    data: function data() {
	        return {
	            timeBrackets: [],
	            currentBracket: null,
	            binList: [],
	            elapsedTime: '',
	            logoutTimeout: true,
	            error: '',
	            remainingLabel: this.$t('loading') + '...',
	            swiperOption: {
	                slidesPerView: 4,
	                slidesPerColumn: 4,
	
	                autoplay: {
	                    delay: 5000,
	                    disableOnInteraction: false
	                },
	                spaceBetween: 15,
	                pagination: {
	                    el: '.swiper-pagination',
	                    clickable: true,
	                    type: 'progressbar'
	                },
	                breakpoints: {
	                    580: {
	                        slidesPerView: 1,
	                        slidesPerColumn: 3,
	                        spaceBetween: 15
	                    },
	
	                    780: {
	                        slidesPerView: 2,
	                        slidesPerColumn: 3,
	                        spaceBetween: 15
	                    },
	
	                    1200: {
	                        slidesPerView: 3,
	                        slidesPerColumn: 3,
	                        spaceBetween: 15
	                    }
	                }
	
	            }
	        };
	    }
	};

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _brandConfig = __webpack_require__(93);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _formatting = __webpack_require__(62);
	
	var _formatting2 = _interopRequireDefault(_formatting);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _OrderHeader = __webpack_require__(136);
	
	var _OrderHeader2 = _interopRequireDefault(_OrderHeader);
	
	var _OrderItems = __webpack_require__(137);
	
	var _OrderItems2 = _interopRequireDefault(_OrderItems);
	
	__webpack_require__(135);
	
	var _vueAwesomeSwiper = __webpack_require__(92);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_POLLING_INTERVAL = 10 * 1000;
	var SCREEN_FLIP_INTERVAL = 8 * 1000;
	var TOTAL_ROWS_PER_COLUMN = 10;
	
	exports.default = {
	
	  name: 'gfb',
	
	  components: {
	    'orderheader': _OrderHeader2.default,
	    'orderitems': _OrderItems2.default,
	    'swiper': _vueAwesomeSwiper.swiper,
	    'slide': _vueAwesomeSwiper.swiperSlide
	  },
	
	  created: function created() {},
	
	  methods: {
	    checkLanguage: function checkLanguage() {
	      if (!_apiBridge2.default.storeNumber) return;
	
	      var self = this;
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getIsEnglish';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        self.getOpenOrders();
	
	        if (!response.data || response.data.error || response.status != 200) {
	          _apiBridge2.default.setLanguage(window.config);
	        } else {
	          _apiBridge2.default.language_flag = '' + response.status;
	
	          console.log('Setting language from api: ' + response.data);
	
	          if (response.data == 'FR') {
	            _apiBridge2.default.language = 'FR';
	          } else {
	            _apiBridge2.default.language = 'EN';
	          }
	        }
	
	        self.$i18n.locale = _apiBridge2.default.language;
	        self.$forceUpdate();
	      });
	    },
	    getOpenOrders: function getOpenOrders() {
	      if (!_apiBridge2.default.storeNumber) return;
	      if (this.pendingOrdersCall) return;
	      console.log('Get open orders');
	
	      var self = this;
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getECommChecks';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	
	      this.pendingOrdersCall = true;
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        self.pendingOrdersCall = false;
	        self.error = '';
	
	        if (_apiBridge2.default.useOverride) {
	          if (response.status != 200) {
	            self.error = self.$t('connection_error');
	            return;
	          }
	        } else if (!response.data || response.data.error || response.status != 200) {
	          self.orderList = [];
	          if (response.nativeError == 'no_data') {} else if (response.nativeError == 'connection_error') {
	            self.error = 'ERR: ' + self.$t('connection_error');
	            return;
	          } else if (response.errorMsg && response.errorMsg.response) {
	            if (response.errorMsg.response.data && response.errorMsg.response.data.error == 'no_data') {} else {
	              self.error = 'ERR: ' + self.$t('connection_error');
	              return;
	            }
	          } else {
	            self.error = 'ERR: ' + self.$t('no_internet');
	            return;
	          }
	        }
	
	        self.processOrders(response.data);
	      });
	    },
	    processOrders: function processOrders(orderListRaw) {
	      var _this = this;
	
	      this.timeCheckField = 'chk_open_date_time';
	      var orderListNew = [];
	      var orderItemsToUpdate = [];
	      var inList = false;
	
	      if (orderListRaw && orderListRaw.length) {
	        for (var r = 0; r < orderListRaw.length; r++) {
	          if (this.filterOutOrder(orderListRaw[r])) {
	            continue;
	          }
	
	          inList = false;
	          for (var n = 0; n < orderListNew.length; n++) {
	            if (orderListRaw[r].checkdetails.chk_num == orderListNew[n].checkdetails.chk_num) {
	              inList = true;
	              if (orderListRaw[r].checkdetails.last_update_tm > orderListNew[n].checkdetails.last_update_tm) {
	                orderListNew[n] = orderListRaw[r];
	              }
	            }
	          }
	          if (!inList && (!orderListRaw[r].checkdetails.autofire_time || orderListRaw[r].checkdetails.autofire_time <= orderListRaw[r].checkdetails.Curr_DT)) {
	            orderListNew.push(orderListRaw[r]);
	          }
	        }
	
	        this.currentTime = orderListRaw[0].checkdetails.Curr_DT ? _formatting2.default.dateFormat.dateFromStr(orderListRaw[0].checkdetails.Curr_DT) : null;
	      }
	
	      for (var _n = 0; _n < orderListNew.length; _n++) {
	        if (this.orderList && this.orderList.length) {
	          inList = false;
	          for (var o = 0; o < this.orderList.length; o++) {
	            if (this.orderList[o].checkdetails.chk_num == orderListNew[_n].checkdetails.chk_num) {
	              inList = true;
	
	              if (this.orderList[o].checkdetails.last_update_tm != orderListNew[_n].checkdetails.last_update_tm) {
	                orderItemsToUpdate.push(this.orderList[o].checkdetails.chk_num);
	              } else if (this.orderList[o].hidden) {
	                orderListNew[_n].hidden = true;
	              } else {
	                if (this.orderList[o].refId) {
	                  orderListNew[_n].refId = this.orderList[o].refId;
	                }
	
	                orderListNew[_n].postPay = this.orderList[o].postPay || false;
	
	                if (this.orderList[o].source) {
	                  orderListNew[_n].source = this.orderList[o].source;
	                }
	              }
	            }
	          }
	          if (!inList) {
	            orderItemsToUpdate.push(orderListNew[_n].checkdetails.chk_num);
	          }
	        } else {
	          orderItemsToUpdate.push(orderListNew[_n].checkdetails.chk_num);
	        }
	
	        this.setOrderDisplay(orderListNew[_n]);
	      }
	
	      this.sortOrders(orderListNew);
	
	      this.orderList = orderListNew;
	
	      if (orderItemsToUpdate.length) {
	        setTimeout(function () {
	          for (var u = 0; u < orderItemsToUpdate.length; u++) {
	            if (_this.$refs['orderItems' + orderItemsToUpdate[u]]) {
	              _this.$refs['orderItems' + orderItemsToUpdate[u]][0].getOrderItems();
	            }
	          }
	        }, 100);
	      }
	
	      var orderPanelDisplay = _apiBridge2.default.appState.orderPanelDisplay;
	      if (orderPanelDisplay) {
	        this.calculatePagesCustom(orderPanelDisplay);
	      } else {
	        this.calculatePagesDefault();
	      }
	    },
	    calculatePagesDefault: function calculatePagesDefault() {
	      var _this2 = this;
	
	      var totalPages = Math.ceil(this.orderList.length / TOTAL_ROWS_PER_COLUMN);
	      this.pagesLeft = [];
	      this.pagesRight = [];
	
	      for (var p = 0; p < totalPages; p++) {
	        if (this.pagesLeft.length) {
	          this.pagesRight.push(this.orderList.slice(p * TOTAL_ROWS_PER_COLUMN, (p + 1) * TOTAL_ROWS_PER_COLUMN));
	        } else {
	          this.pagesLeft.push(this.orderList.slice(p * TOTAL_ROWS_PER_COLUMN, (p + 1) * TOTAL_ROWS_PER_COLUMN));
	        }
	      }
	
	      if (totalPages > 2 && totalPages > this.totalPages) {
	        setTimeout(function () {
	          var panelFlipperRight = _this2.$refs.panelFlipperRight;
	          panelFlipperRight.swiper.update();
	          panelFlipperRight.swiper.slideTo(1);
	        }, 200);
	      }
	
	      this.totalPages = totalPages;
	    },
	    calculatePagesCustom: function calculatePagesCustom(orderPanelDisplay) {
	      var _this3 = this;
	
	      this.pagesLeft = [];
	      this.pagesRight = [];
	
	      for (var o = 0; o < this.orderList.length; o++) {
	        if (orderPanelDisplay.left.length) {
	          for (var l = 0; l < orderPanelDisplay.left.length; l++) {
	            if ((0, _utils.checkFilterCriteria)(orderPanelDisplay.left[l].channel, this.orderList[o].checkdetails.last_name) && (0, _utils.checkFilterCriteria)(orderPanelDisplay.left[l].type, this.orderList[o].checkdetails.name)) {
	              if (this.pagesLeft.length && this.pagesLeft[this.pagesLeft.length - 1].length < TOTAL_ROWS_PER_COLUMN) {
	                this.pagesLeft[this.pagesLeft.length - 1].push(this.orderList[o]);
	              } else {
	                this.pagesLeft.push([]);
	                this.pagesLeft[this.pagesLeft.length - 1].push(this.orderList[o]);
	              }
	            }
	          }
	        }
	
	        if (orderPanelDisplay.right.length) {
	          for (var r = 0; r < orderPanelDisplay.right.length; r++) {
	            if ((0, _utils.checkFilterCriteria)(orderPanelDisplay.right[r].channel, this.orderList[o].checkdetails.last_name) && (0, _utils.checkFilterCriteria)(orderPanelDisplay.right[r].type, this.orderList[o].checkdetails.name)) {
	              if (this.pagesRight.length && this.pagesRight[this.pagesRight.length - 1].length < TOTAL_ROWS_PER_COLUMN) {
	                this.pagesRight[this.pagesRight.length - 1].push(this.orderList[o]);
	              } else {
	                this.pagesRight.push([]);
	                this.pagesRight[this.pagesRight.length - 1].push(this.orderList[o]);
	              }
	            }
	          }
	        }
	      }
	
	      if (this.pagesLeft.length > 1 && this.pagesLeft.length > this.totalPagesLeft) {
	        setTimeout(function () {
	          var panelFlipperLeft = _this3.$refs.panelFlipperLeft;
	          panelFlipperLeft.swiper.update();
	          panelFlipperLeft.swiper.slideTo(1);
	        }, 200);
	      }
	      this.totalPagesLeft = this.pagesLeft.length;
	
	      if (this.pagesRight.length > 1 && this.pagesRight.length > this.totalPagesRight) {
	        setTimeout(function () {
	          var panelFlipperRight = _this3.$refs.panelFlipperRight;
	          panelFlipperRight.swiper.update();
	          panelFlipperRight.swiper.slideTo(1);
	        }, 200);
	      }
	      this.totalPagesRight = this.pagesRight.length;
	    },
	    filterOutOrder: function filterOutOrder(order) {
	      var excludeList = _apiBridge2.default.appState.orderChannelExclusionList;
	      if (excludeList && excludeList.length) {
	        for (var e = 0; e < excludeList.length; e++) {
	          if ((0, _utils.checkFilterCriteria)(excludeList[e].channel, order.checkdetails.last_name) && (0, _utils.checkFilterCriteria)(excludeList[e].type, order.checkdetails.name)) {
	
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    sortOrders: function sortOrders(orderList) {
	      if (!orderList) {
	        orderList = this.orderList;
	      }
	
	      var self = this;
	
	      var statusOrder = ['Visit Counter', 'Ready to Go!'];
	
	      orderList.sort(function (a, b) {
	
	        var dta = _formatting2.default.dateFormat.dateFromStr(a.checkdetails[self.timeCheckField]);
	        var dtb = _formatting2.default.dateFormat.dateFromStr(b.checkdetails[self.timeCheckField]);
	
	        if (dta > dtb) return 1;
	        if (dta < dtb) return -1;
	        return 0;
	      });
	    },
	    setOrderDisplay: function setOrderDisplay(order) {
	      var _this4 = this;
	
	      var aggOrder = false;
	
	      switch (order.checkdetails.obj_num) {
	        case 2002:
	        case 9999:
	          order.source = 'Online Order';
	          if (order.postPay && !order.checkdetails.chk_clsd_date_time) {
	            order.status = 'cashier';
	          }
	          break;
	        case 106:
	        case 105:
	        case 111:
	          order.source = 'Take Out';
	          break;
	        case 3000:
	        case 3001:
	        case 3002:
	        case 3003:
	        case 3004:
	          order.source = _brandConfig2.default.aggregatorNameRemap(order.checkdetails.last_name);
	          aggOrder = true;
	          break;
	        default:
	          order.source = order.checkdetails.last_name;
	      }
	
	      if (!order.status) {
	        if (order.checkdetails.readyTime) {
	          order.status = 'ready';
	          setTimeout(function () {
	            _this4.setReadyDisplay(order);
	          }, 200);
	        } else {
	          order.status = 'prep';
	        }
	      }
	
	      if (order.status == 'ready') {
	        order.color = '#01B51A';
	      } else {
	        order.color = 'black';
	      }
	
	      if (order.checkdetails.id && !aggOrder) {
	        if (order.checkdetails.id.indexOf('-') >= 0) {
	          order.displayName = '';
	          var aName = order.checkdetails.id.split('-');
	
	          for (var n = 0; n < aName.length; n++) {
	            var sTest = aName[n].replace(/\d+/g, '');
	            if (!sTest) {
	              order.displayName += ' - ' + _formatting2.default.numberFormat.pad(aName[n], 3);
	            } else {
	              order.displayName = order.displayName ? order.displayName + '-' + aName[n] : _formatting2.default.stringFormat.capitalize(aName[n]);
	            }
	          }
	        } else {
	          order.checkdetails.id = order.checkdetails.id.replace(/\*/g, '');
	          if (order.checkdetails.id) {
	            order.displayName = _formatting2.default.stringFormat.capitalize(order.checkdetails.id) + ' - ' + order.checkdetails.chk_num;
	          } else {
	            order.displayName = order.source + ' - ' + order.checkdetails.chk_num;
	          }
	        }
	      } else {
	        if (order.refId) {
	          if (order.source == 'Take Out') {
	            order.displayName = _formatting2.default.stringFormat.capitalize(order.refId) + ' - ' + order.checkdetails.chk_num;
	          } else {
	            order.displayName = order.source + ' - ' + _formatting2.default.stringFormat.capitalize(order.refId);
	          }
	        } else if (order.checkdetails.id) {
	          order.displayName = order.source + ' - ' + _formatting2.default.stringFormat.capitalize(order.checkdetails.id);
	        } else {
	          order.displayName = order.source + ' - ' + order.checkdetails.chk_num;
	        }
	      }
	    },
	    refreshOrders: function refreshOrders() {
	      for (var o = 0; o < this.orderList.length; o++) {
	        if (this.orderItemsHash['' + this.orderList[o].checkdetails.chk_num] && this.$refs['orderItems' + this.orderList[o].checkdetails.chk_num] && this.$refs['orderItems' + this.orderList[o].checkdetails.chk_num][0]) {}
	
	        if (this.orderList[o].ready) {
	          this.setReady(this.$refs['order' + this.orderList[o].checkdetails.chk_num][0]);
	        }
	      }
	    },
	    setReadyDisplay: function setReadyDisplay(order) {
	      if (!order || !order.checkdetails) return;
	      this.setBorder(this.$refs['order' + order.checkdetails.chk_num][0], true, false);
	    },
	    setSeeCashierDisplay: function setSeeCashierDisplay(order) {
	      if (!order || !order.checkdetails) return;
	      this.setBorder(this.$refs['order' + order.checkdetails.chk_num][0], true, true);
	    },
	    deselectOrder: function deselectOrder(order) {
	      if (!order || !order.checkdetails) return;
	
	      this.setBorder(this.$refs['order' + order.checkdetails.chk_num][0], false);
	      this.selectedOrder = null;
	    },
	    hideOrder: function hideOrder(orderInfo) {
	      for (var o = 0; o < this.orderList.length; o++) {
	        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
	          this.orderList[o].hidden = true;
	        }
	      }
	      this.$forceUpdate();
	    },
	    updateOrder: function updateOrder(orderInfo) {
	      for (var o = 0; o < this.orderList.length; o++) {
	        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
	          this.orderItemsHash['' + orderInfo.orderId] = {
	            items: orderInfo.processedItems,
	            orderTicket: orderInfo.orderTicket,
	            refId: orderInfo.refId,
	            postPay: orderInfo.postPay
	          };
	
	          this.orderList[o].refId = orderInfo.refId || '';
	          this.orderList[o].postPay = orderInfo.postPay || false;
	
	          if (orderInfo.voided) {
	            this.orderList[o].hidden = true;
	          } else {
	            this.setOrderDisplay(this.orderList[o]);
	          }
	
	          this.$forceUpdate();
	
	          break;
	        }
	      }
	    },
	    setBorder: function setBorder(panel, selected, ready) {
	      if (!panel) return;
	      var selStyle = ready ? 'selected2' : 'selected';
	      if (selected) {
	        panel.classList.add(selStyle);
	      } else {
	        panel.classList.remove(selStyle);
	      }
	    },
	    setDataPolling: function setDataPolling(flag, duration) {
	      var _this5 = this;
	
	      if (flag) {
	        console.log('Setting polling interval to: ' + duration);
	        this.pollingInterval = setInterval(function () {
	          _this5.getOpenOrders();
	        }, duration || DEFAULT_POLLING_INTERVAL);
	      } else {
	        console.log('Stopped polling.');
	        if (this.pollingInterval) clearInterval(this.pollingInterval);
	      }
	    },
	    gotoInfo: function gotoInfo() {
	      _router2.default.push('/info');
	    },
	    reload: function reload() {
	      location.reload(true);
	    },
	    calculateRowsForHeight: function calculateRowsForHeight() {
	      var rowHeight = 70;
	      var screenHeight = window.innerHeight * 0.87;
	
	      this.totalRows = parseInt(screenHeight / rowHeight);
	    },
	    startElapsedTime: function startElapsedTime() {
	      var _this6 = this;
	
	      if (this.elapsedTimeInterval) clearInterval(this.elapsedTimeInterval);
	      this.elapsedTimeInterval = setInterval(function () {
	        _this6.updateElapsedTime();
	      }, 10000);
	    },
	    updateElapsedTime: function updateElapsedTime() {
	      var _this7 = this;
	
	      if (this.currentTime) {
	        this.currentTime.setSeconds(this.currentTime.getSeconds() + 10);
	
	        if (this.orderList && this.orderList.length) {
	          var o;
	
	          (function () {
	            var autoBumpCount = 0;
	            for (o = 0; o < _this7.orderList.length; o++) {
	
	              var sOrderTime = _this7.orderList[o].checkdetails.readyTime;
	              var dtOrderTime = _formatting2.default.dateFormat.dateFromStr(sOrderTime);
	              var oElapsedTime = _formatting2.default.dateFormat.calcElapsedTime(dtOrderTime, _this7.currentTime);
	
	              if (_this7.checkAutoBump(_this7.orderList[o], oElapsedTime.totalMinutes)) {
	                var _ret2 = function () {
	                  console.log('Auto-Bump: ' + _this7.orderList[o].checkdetails.chk_num + ' - ' + oElapsedTime.totalMinutes);
	
	                  var orderToBump = _this7.orderList[o];
	
	                  setTimeout(function () {
	                    _this7.bumpOrder(orderToBump);
	                    autoBumpCount++;
	                  }, autoBumpCount * 500);
	
	                  _this7.orderList.splice(o, 1);
	                  return 'continue';
	                }();
	
	                if (_ret2 === 'continue') continue;
	              }
	            }
	          })();
	        }
	      }
	    },
	    checkAutoBump: function checkAutoBump(order, minutes) {
	      if (order.status == 'ready' && !order.hidden && minutes >= _apiBridge2.default.appState.autoBumpMinutes) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    bumpOrder: function bumpOrder(order, resultCallback) {
	      var self = this;
	      var orderId = order.checkdetails.chk_num;
	
	      console.log('Bump order: ' + orderId);
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getBumpCheck';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	      apiParameters.queryString['check_num'] = orderId;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        if (!response || response.data != 99) {
	          console.log('Bump api call failed for order: ' + orderId);
	          return;
	        }
	      });
	    },
	    init: function init(pollingInterval) {
	      var _this8 = this;
	
	      this.storeNumber = _apiBridge2.default.storeNumber;
	
	      var language = '' + (0, _utils.getQueryStringParameterByName)('language');
	      if (language) {
	        _apiBridge2.default.language_flag = 'querystring';
	        if (language.toLocaleUpperCase() == 'FR') {
	          _apiBridge2.default.language = 'FR';
	        } else {
	          _apiBridge2.default.language = 'EN';
	        }
	        this.$i18n.locale = _apiBridge2.default.language;
	        this.$forceUpdate();
	      }
	
	      if (_apiBridge2.default.language_flag === null) {
	        this.checkLanguage();
	      } else {
	        this.getOpenOrders();
	      }
	
	      if (_apiBridge2.default.brand) {
	        this.logoPath = 'static/assets/brand_logo_' + _apiBridge2.default.brand + '.png';
	
	        if (_apiBridge2.default.brand == 'harveys') {
	          this.bannerStyle = 'background-color: #e87726;';
	          this.bannerStyle = 'display: none;';
	
	          this.headerLeft = this.$t('mobile_app_pickup');
	          this.headerRight = this.$t('delivery_pickup');
	
	          this.logoLeftPath = 'static/assets/harveys_pickup.png';
	          this.logoRightPath = 'static/assets/harveys_delivery.png';
	        } else {
	          this.bannerStyle = 'background-color: #ED1C24;';
	        }
	      }
	
	      setTimeout(function () {
	        _this8.getOpenOrders();
	      }, 2000);
	
	      this.orderItemsHash = {};
	      this.setDataPolling(true, pollingInterval);
	
	      this.startElapsedTime();
	
	      (0, _utils.idFullStory)(this.storeNumber);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this9 = this;
	
	    console.log('Guest Facing Board page');
	
	    _apiBridge2.default.getState();
	    _apiBridge2.default.setStore(_apiBridge2.default.storeNumber);
	
	    document.body.style.backgroundColor = "#FFFFFF";
	
	    if (this.$route.params.storeID) {
	      var storeID = parseInt(this.$route.params.storeID);
	      _apiBridge2.default.setStore(storeID);
	    }
	
	    if (_apiBridge2.default.storeSelected && _apiBridge2.default.storeNumber) {
	      this.init();
	    } else {
	      if (false) {
	        _router2.default.push('/login');
	      } else {
	        this.initInterval = setInterval(function () {
	          if (window.config && window.config.storeId) {
	
	            clearInterval(_this9.initInterval);
	
	            _apiBridge2.default.setStore(window.config.storeId);
	            _apiBridge2.default.setLanguage(window.config);
	            _apiBridge2.default.setProxy(window.config);
	
	            var pollingInterval = DEFAULT_POLLING_INTERVAL;
	
	            if (!_apiBridge2.default.useProxyApi && window.config.refreshRate) {
	              pollingInterval = 1000 * parseInt(window.config.refreshRate);
	            }
	
	            _this9.init(pollingInterval);
	          }
	        }, 500);
	      }
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    if (this.pollingInterval) clearInterval(this.pollingInterval);
	    if (this.initInterval) clearInterval(this.initInterval);
	  },
	  data: function data() {
	    return {
	      orderList: [],
	      pendingOrdersCall: false,
	      selectedOrder: null,
	      panelAnimation: [],
	      panelShrink: [],
	      panelFade: [],
	      elapsedTime: [],
	      currentTime: null,
	      storeNumber: _apiBridge2.default.storeNumber,
	      totalRows: TOTAL_ROWS_PER_COLUMN,
	      totalPages: 0,
	      pagesLeft: [],
	      pagesRight: [],
	      totalPagesLeft: 0,
	      totalPagesRight: 0,
	      headerLeft: '',
	      headerRight: '',
	      logoLeftPath: '',
	      logoRightPath: '',
	      logoPath: 'static/assets/brand_logo_swiss.png',
	      bannerStyle: 'background-color: #ED1C24;',
	      swiperOption: {
	        slidesPerView: 'auto',
	        direction: 'vertical',
	        centeredSlides: false,
	        preventClicks: false,
	        preventClicksPropagation: false,
	        spaceBetween: 5,
	        allowTouchMove: true,
	        slideToClickedSlide: true
	      },
	      swiperOptionh: {
	        spaceBetween: 0,
	        autoplay: {
	          delay: SCREEN_FLIP_INTERVAL,
	          disableOnInteraction: false
	        }
	      },
	      error: '...'
	    };
	  }
	};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    logout: function logout() {
	      var _this = this;
	
	      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logout) {
	        window.webkit.messageHandlers.logout.postMessage(null);
	      } else {
	        _apiBridge2.default.storeSelected = false;
	        _apiBridge2.default.storeNumber = null;
	        _apiBridge2.default.setStore(0);
	
	        _router2.default.push('/login');
	
	        setTimeout(function () {
	          _this.reload();
	        }, 200);
	      }
	    },
	    gotoBack: function gotoBack() {
	      _router2.default.back();
	    },
	    reload: function reload() {
	      location.reload(true);
	    }
	  },
	
	  mounted: function mounted() {
	    console.log('Info page');
	
	    document.body.style.backgroundColor = "#000";
	
	    if (window.config) {
	      this.version = window.config.version;
	      this.ip = window.config.ip;
	    }
	  },
	
	  data: function data() {
	    return {
	      storeNumber: _apiBridge2.default.storeNumber,
	      version: '??',
	      ip: '??',
	      build: ("2022-09-06-t19"),
	      error: ''
	    };
	  }
	};

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _formatting = __webpack_require__(62);
	
	var _formatting2 = _interopRequireDefault(_formatting);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _OrderHeader = __webpack_require__(136);
	
	var _OrderHeader2 = _interopRequireDefault(_OrderHeader);
	
	var _OrderItems = __webpack_require__(137);
	
	var _OrderItems2 = _interopRequireDefault(_OrderItems);
	
	__webpack_require__(135);
	
	var _vueAwesomeSwiper = __webpack_require__(92);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_POLLING_INTERVAL = 20 * 1000;
	var DISPLAY_LIMIT_FOR_PREP_SCREEN = 20;
	
	exports.default = {
	
	  name: 'kds',
	
	  components: {
	    'orderheader': _OrderHeader2.default,
	    'orderitems': _OrderItems2.default,
	    'swiper': _vueAwesomeSwiper.swiper,
	    'slide': _vueAwesomeSwiper.swiperSlide
	  },
	
	  props: {
	    readyOrdersDisplay: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  created: function created() {},
	
	  methods: {
	    checkLanguage: function checkLanguage() {
	      if (!_apiBridge2.default.storeNumber) return;
	
	      var self = this;
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getIsEnglish';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        self.getOpenOrders();
	
	        if (!response.data || response.data.error || response.status != 200) {
	          _apiBridge2.default.setLanguage(window.config);
	        } else {
	          _apiBridge2.default.language_flag = '' + response.status;
	
	          console.log('Setting language from api: ' + response.data);
	
	          if (response.data == 'FR') {
	            _apiBridge2.default.language = 'FR';
	          } else {
	            _apiBridge2.default.language = 'EN';
	          }
	        }
	
	        self.$i18n.locale = _apiBridge2.default.language;
	        self.$forceUpdate();
	      });
	    },
	    getOpenOrders: function getOpenOrders(resultCallback) {
	      if (!_apiBridge2.default.storeNumber) return;
	      if (this.pendingOrdersCall) return;
	
	      console.log('Get open orders');
	
	      var self = this;
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getECommChecks';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	
	      this.pendingOrdersCall = true;
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        self.pendingOrdersCall = false;
	        self.error = '';
	
	        if (_apiBridge2.default.useOverride) {
	          if (response.status != 200) {
	            self.error = self.$t('connection_error');
	            return;
	          }
	        } else if (!response.data || response.data.error || response.status != 200) {
	          self.orderList = [];
	          if (response.nativeError == 'no_data') {} else if (response.nativeError == 'connection_error') {
	            self.error = 'ERR: ' + self.$t('connection_error');
	            return;
	          } else if (response.errorMsg && response.errorMsg.response) {
	            if (response.errorMsg.response.data && response.errorMsg.response.data.error == 'no_data') {} else {
	              self.error = 'ERR: ' + self.$t('connection_error');
	              return;
	            }
	          } else {
	            self.error = 'ERR: ' + self.$t('no_internet');
	            return;
	          }
	        }
	
	        self.processOrders(response.data);
	
	        if (typeof resultCallback === "function") {
	          resultCallback(response);
	        }
	      });
	    },
	    processOrders: function processOrders(orderListRaw) {
	      var _this = this;
	
	      var orderListNew = [];
	      var orderItemsToUpdate = [];
	      var inList = false;
	      var newOrder = false;
	
	      if (this.readyOrdersDisplay) {
	        this.timeCheckField = 'readyTime';
	      } else {
	        this.timeCheckField = 'chk_open_date_time';
	      }
	
	      if (orderListRaw && orderListRaw.length) {
	        this.currentTime = orderListRaw[0].checkdetails.Curr_DT ? _formatting2.default.dateFormat.dateFromStr(orderListRaw[0].checkdetails.Curr_DT) : null;
	
	        this.autoBumpCount = 0;
	
	        orderListRaw = orderListRaw.filter(this.filterOutOrder);
	
	        var pendingNewOrders = [];
	        orderListRaw = orderListRaw.filter(function (order) {
	          if (_this.orderItemsHash['' + order.checkdetails.chk_num]) {
	            return true;
	          } else {
	            if (_this.refreshDelay) {
	              order.newOrder = true;
	            }
	            pendingNewOrders.push(order);
	            return false;
	          }
	        });
	
	        orderListRaw.sort(function (a, b) {
	          if (_this.orderItemsHash['' + a.checkdetails.chk_num] && _this.orderItemsHash['' + b.checkdetails.chk_num]) {
	            var indexa = _this.orderItemsHash['' + a.checkdetails.chk_num].orderObject.sortIndex;
	            var indexb = _this.orderItemsHash['' + b.checkdetails.chk_num].orderObject.sortIndex;
	
	            if (indexa > indexb) return 1;
	            if (indexa < indexb) return -1;
	            return 0;
	          }
	        });
	
	        pendingNewOrders.sort(function (a, b) {
	          var dta = _formatting2.default.dateFormat.dateFromStr(a.checkdetails[_this.timeCheckField]);
	          var dtb = _formatting2.default.dateFormat.dateFromStr(b.checkdetails[_this.timeCheckField]);
	
	          if (dta > dtb) return 1;
	          if (dta < dtb) return -1;
	          return 0;
	        });
	
	        orderListRaw = orderListRaw.concat(pendingNewOrders);
	
	        var len = !this.readyOrdersDisplay && orderListRaw.length > DISPLAY_LIMIT_FOR_PREP_SCREEN ? DISPLAY_LIMIT_FOR_PREP_SCREEN : orderListRaw.length;
	
	        for (var r = 0; r < len; r++) {
	          inList = false;
	          for (var n = 0; n < orderListNew.length; n++) {
	            if (orderListRaw[r].checkdetails.chk_num == orderListNew[n].checkdetails.chk_num) {
	              inList = true;
	              if (orderListRaw[r].checkdetails.last_update_tm > orderListNew[n].checkdetails.last_update_tm || orderListRaw[r].checkdetails.trans_seq > orderListNew[n].checkdetails.trans_seq) {
	                orderListNew[n] = orderListRaw[r];
	              }
	            }
	          }
	          if (!inList && (!orderListRaw[r].checkdetails.autofire_time || orderListRaw[r].checkdetails.autofire_time <= orderListRaw[r].checkdetails.Curr_DT)) {
	            orderListNew.push(orderListRaw[r]);
	          }
	        }
	      }
	
	      for (var _n = 0; _n < orderListNew.length; _n++) {
	        if (this.orderList && this.orderList.length) {
	          inList = false;
	          for (var o = 0; o < this.orderList.length; o++) {
	            if (this.orderList[o].checkdetails.chk_num == orderListNew[_n].checkdetails.chk_num) {
	              inList = true;
	
	              if (this.orderList[o].checkdetails.last_update_tm != orderListNew[_n].checkdetails.last_update_tm || this.orderList[o].checkdetails.trans_seq != orderListNew[_n].checkdetails.trans_seq) {
	                orderItemsToUpdate.push({
	                  chk_num: this.orderList[o].checkdetails.chk_num,
	                  existing: true
	                });
	              } else if (this.orderList[o].hidden) {
	                orderListNew[_n].hidden = true;
	              } else {
	                if (this.orderList[o].refId) {
	                  orderListNew[_n].refId = this.orderList[o].refId;
	                }
	
	                orderListNew[_n].postPay = this.orderList[o].postPay || false;
	
	                if (this.orderList[o].source) {
	                  orderListNew[_n].source = this.orderList[o].source;
	                }
	              }
	            }
	          }
	          if (!inList) {
	            orderItemsToUpdate.push({
	              chk_num: orderListNew[_n].checkdetails.chk_num,
	              existing: false
	            });
	          }
	        } else {
	          orderItemsToUpdate.push({
	            chk_num: orderListNew[_n].checkdetails.chk_num,
	            existing: false
	          });
	        }
	      }
	
	      this.refreshDelay = true;
	
	      this.orderList = orderListNew;
	      this.$forceUpdate();
	
	      if (orderItemsToUpdate.length) {
	        setTimeout(function () {
	          for (var u = 0; u < orderItemsToUpdate.length; u++) {
	            if (orderItemsToUpdate[u].existing) {
	              _this.updateOrderItems(orderItemsToUpdate[u].chk_num);
	            }
	
	            _this.resetSize({ orderId: orderItemsToUpdate[u].chk_num, listContainer: { scrollHeight: 0, children: [] } });
	          }
	        }, 10);
	      }
	
	      this.panelAnimation = [];
	      this.panelShrink = [];
	      this.panelFade = [];
	      if (this.orderList && this.orderList.length) {
	        for (var _o = 0; _o < this.orderList.length; _o++) {
	          this.panelAnimation.push(true);
	          this.panelShrink.push(false);
	          this.panelFade.push(false);
	
	          this.orderList[_o].sortIndex = _o;
	
	          if (!this.orderItemsHash['' + this.orderList[_o].checkdetails.chk_num]) {
	            this.orderItemsHash['' + this.orderList[_o].checkdetails.chk_num] = {
	              orderId: this.orderList[_o].checkdetails.chk_num,
	              orderObject: this.orderList[_o]
	            };
	          } else {
	            this.resetSize(this.orderItemsHash['' + this.orderList[_o].checkdetails.chk_num]);
	          }
	        }
	      }
	    },
	    filterOutOrder: function filterOutOrder(order) {
	      var _this2 = this;
	
	      if (this.readyOrdersDisplay) {
	        if (!order.checkdetails.readyTime) {
	          return false;
	        }
	      } else {
	        if (order.checkdetails.readyTime) {
	          return false;
	        }
	      }
	
	      var excludeList = _apiBridge2.default.appState.orderChannelExclusionList;
	      if (excludeList && excludeList.length) {
	        for (var e = 0; e < excludeList.length; e++) {
	          if ((0, _utils.checkFilterCriteria)(excludeList[e].channel, order.checkdetails.last_name) && (0, _utils.checkFilterCriteria)(excludeList[e].type, order.checkdetails.name)) {
	            if (!_apiBridge2.default.useMockData && !_apiBridge2.default.useProxyApi) {
	              this.bumpOrder(order);
	            }
	
	            return false;
	          }
	
	          if ((0, _utils.checkFilterCriteria)(excludeList[e].emp_num, order.checkdetails.emp_num) && (0, _utils.checkFilterCriteria)(excludeList[e].type, order.checkdetails.name)) {
	
	            return false;
	          }
	        }
	      }
	
	      if (this.readyOrdersDisplay) {
	        var sOrderTime = order.checkdetails.readyTime;
	        var dtOrderTime = _formatting2.default.dateFormat.dateFromStr(sOrderTime);
	        var oElapsedTime = _formatting2.default.dateFormat.calcElapsedTime(dtOrderTime, this.currentTime);
	
	        if (this.checkAutoBump(order, oElapsedTime.totalMinutes)) {
	          console.log('Auto-Bump: ' + order.checkdetails.chk_num + ' - ' + oElapsedTime.totalMinutes);
	
	          setTimeout(function () {
	            _this2.bumpOrder(order);
	            _this2.autoBumpCount++;
	          }, this.autoBumpCount * 500);
	
	          return false;
	        }
	      }
	
	      return true;
	    },
	    updateOrderItems: function updateOrderItems(orderId) {
	      var itemsObj = this.$refs['orderItems' + orderId];
	      if (itemsObj && itemsObj[0]) {
	        this.setLoaderDisplay(orderId, true);
	
	        itemsObj[0].getOrderItems();
	      }
	    },
	    checkAutoBump: function checkAutoBump(order, minutes) {
	      if (_apiBridge2.default.useMockData || _apiBridge2.default.useProxyApi) return false;
	
	      if (!order.postPay && minutes >= _apiBridge2.default.appState.autoBumpMinutes) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    checkForPendingItemRefresh: function checkForPendingItemRefresh() {
	      for (var o = 0; o < this.orderList.length; o++) {
	        if (this.$refs['orderItems' + this.orderList[o].checkdetails.chk_num] && this.$refs['orderItems' + this.orderList[o].checkdetails.chk_num][0]) {
	
	          var orderItems = this.$refs['orderItems' + this.orderList[o].checkdetails.chk_num];
	          if (orderItems[0].visibility == 'hidden') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    initiateAppPush: function initiateAppPush(orderTicket) {
	      _apiBridge2.default.vmPushNotification(orderTicket, function (success) {
	        if (success) {
	          console.log('Push Notification sent');
	
	          _apiBridge2.default.appState.pushNotificationList.push(orderTicket);
	        } else {
	          console.log('Push Notification failed');
	        }
	      });
	    },
	    bumpOrder: function bumpOrder(order, resultCallback) {
	      var self = this;
	      var orderId = order.checkdetails.chk_num;
	
	      this.handleActionResponse();
	
	      console.log('Bump order: ' + orderId);
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getBumpCheck';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	      apiParameters.queryString['check_num'] = orderId;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        if (!response || response.data != 99) {
	          console.log('Bump api call failed for order: ' + orderId);
	        }
	
	        delete self.orderItemsHash['' + order.checkdetails.chk_num];
	
	        if (typeof resultCallback === "function") {
	          resultCallback(response);
	        }
	      });
	    },
	    readyOrder: function readyOrder(order, resultCallback) {
	
	      var self = this;
	      var orderId = order.checkdetails.chk_num;
	
	      this.handleActionResponse();
	
	      console.log('Ready order: ' + orderId);
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getReadyCheck';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	      apiParameters.queryString['check_num'] = orderId;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        if (!response || response.data != 99) {
	          console.log('Ready api call failed for order: ' + orderId);
	        } else {
	          if (self.orderItemsHash['' + order.checkdetails.chk_num]) {
	            var orderTicket = self.orderItemsHash['' + order.checkdetails.chk_num].orderTicket;
	
	            if (orderTicket && _apiBridge2.default.appState.pushNotificationList.indexOf(orderTicket) == -1) {
	              self.initiateAppPush(orderTicket);
	            }
	
	            delete self.orderItemsHash['' + order.checkdetails.chk_num];
	          }
	        }
	
	        if (typeof resultCallback === "function") {
	          resultCallback(response);
	        }
	      });
	    },
	    recallOrder: function recallOrder(order, resultCallback) {
	      console.log('Recall order:' + orderId);
	      var orderId = order.checkdetails.chk_num;
	
	      this.handleActionResponse();
	
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getRecallCheck';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	      apiParameters.queryString['check_num'] = orderId;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        if (!response || response.data != 99) {
	          console.log('Recalll api call failed for order: ' + orderId);
	        }
	
	        if (typeof resultCallback === "function") {
	          resultCallback(response);
	        }
	      });
	    },
	    actionLaunch: function actionLaunch(actionType) {
	      if (this.pendingOrdersCall || this.checkForPendingItemRefresh()) return;
	
	      this.actionInProgress = true;
	
	      if (!this.selectedOrder) return;
	
	      switch (actionType) {
	        case 'bump':
	          this.bumpOrder(this.selectedOrder);
	          break;
	        case 'ready':
	          this.readyOrder(this.selectedOrder);
	          break;
	        case 'recall':
	          this.recallOrder(this.selectedOrder);
	          break;
	        default:
	          console.warn('Wrong action parameter');
	      }
	    },
	    handleActionResponse: function handleActionResponse() {
	      var _this3 = this;
	
	      var self = this;
	      if (!self.selectedOrder) return;
	
	      var index = self.orderList.indexOf(self.selectedOrder);
	
	      if (this.detailView) {
	        self.$refs['orderItems' + self.selectedOrder.checkdetails.chk_num][0].clearOrderItems();
	      }
	
	      self.panelShrink[index] = true;
	      self.$forceUpdate();
	
	      setTimeout(function () {
	        self.panelFade[index] = true;
	        self.$forceUpdate();
	      }, 200);
	
	      setTimeout(function () {
	        self.panelAnimation[index] = false;
	        if (self.selectedOrder) {
	          var i = self.orderList.indexOf(self.selectedOrder);
	          self.orderList.splice(i, 1);
	          self.selectedOrder = null;
	          self.$forceUpdate();
	        }
	
	        _this3.actionFinish();
	      }, 400);
	    },
	    actionFinish: function actionFinish() {
	      var _this4 = this;
	
	      this.$nextTick(function () {
	        _this4.panelAnimation = [];
	        _this4.panelShrink = [];
	        _this4.panelFade = [];
	
	        _this4.orderList.forEach(function (order) {
	          _this4.deselectOrder(order);
	          _this4.panelAnimation.push(false);
	          _this4.panelShrink.push(false);
	          _this4.panelFade.push(false);
	        });
	      });
	
	      this.refreshDelay = false;
	      setTimeout(function () {
	        _this4.refreshDelay = true;
	        _this4.$forceUpdate();
	      }, 5000);
	
	      setTimeout(function () {
	        for (var i = 0; i < _this4.panelAnimation.length; i++) {
	          _this4.panelAnimation[i] = true;
	        }
	
	        _this4.$forceUpdate();
	
	        _this4.$nextTick(function () {
	          _this4.orderList = [];
	          _this4.orderItemsHash = {};
	          _this4.selectedOrder = null;
	
	          _this4.getOpenOrders();
	
	          if (_this4.$refs.orderSwiper) {
	            _this4.$refs.orderSwiper.swiper.slideTo(0, 100, false);
	          }
	
	          _this4.actionButton = _this4.readyOrdersDisplay || !_this4.showReady ? 'bump' : 'ready';
	
	          _this4.setDataPolling(true);
	
	          _this4.actionInProgress = false;
	        });
	      }, 200);
	
	      this.setDataPolling(false);
	      this.$forceUpdate();
	    },
	    hideOrder: function hideOrder(orderInfo) {
	      for (var o = 0; o < this.orderList.length; o++) {
	        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
	          this.orderList[o].hidden = true;
	
	          if (!_apiBridge2.default.useMockData && !_apiBridge2.default.useProxyApi) {
	            this.bumpOrder(this.orderList[o]);
	          }
	        }
	      }
	      this.$forceUpdate();
	    },
	    visibilityChanged: function visibilityChanged(isVisible, entry) {
	      if (isVisible) {
	        this.updateOrderItems(entry.target.id);
	      }
	    },
	    updateOrder: function updateOrder(orderInfo) {
	      var orderObject = {};
	      for (var o = 0; o < this.orderList.length; o++) {
	        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
	          this.orderList[o].refId = orderInfo.refId || '';
	          this.orderList[o].postPay = orderInfo.postPay || false;
	
	          if (orderInfo.voided) {
	            this.orderList[o].hidden = true;
	
	            if (!_apiBridge2.default.useMockData && !_apiBridge2.default.useProxyApi) {
	              this.bumpOrder(this.orderList[o]);
	            }
	          } else {
	            if (this.orderList[o].newOrder) {
	              delete this.orderList[o].newOrder;
	              this.$parent.orderSoundPlay();
	            }
	
	            orderObject = this.orderList[o];
	          }
	
	          this.$forceUpdate();
	
	          break;
	        }
	      }
	
	      if (orderInfo.updateHash) {
	        this.orderItemsHash['' + orderInfo.orderId] = {
	          orderId: orderInfo.orderId,
	          orderObject: orderObject,
	          items: orderInfo.processedItems,
	          orderTicket: orderInfo.orderTicket,
	          refId: orderInfo.refId,
	          postPay: orderInfo.postPay,
	          listContainer: orderInfo.listContainer
	        };
	      }
	
	      this.setLoaderDisplay(orderInfo.orderId, false);
	
	      this.resetSize(orderInfo);
	    },
	    setLoaderDisplay: function setLoaderDisplay(orderId, flag) {
	      var orderLoader = this.$refs['loader' + orderId];
	      if (orderLoader && orderLoader[0]) {
	        if (flag) {
	          orderLoader[0].setAttribute('style', 'display:block');
	        } else {
	          orderLoader[0].setAttribute('style', 'display:none');
	        }
	      }
	    },
	    toggleOrderSelect: function toggleOrderSelect(order) {
	      if (this.readyOrdersDisplay) {
	        if (this.selectedOrder == order && order.displayStatus == 'bump') {
	          order.displayStatus = 'return';
	          this.selectOrder(order, order.displayStatus);
	
	          this.actionButton = 'return';
	        } else if (this.selectedOrder == order && order.displayStatus == 'return') {
	          order.displayStatus = 'ready';
	          this.deselectOrder(order, order.displayStatus);
	
	          this.actionButton = 'bump';
	        } else {
	          if (this.selectedOrder && this.selectedOrder.checkdetails.chk_num) {
	            this.deselectOrder(this.selectedOrder, 'ready');
	          }
	          order.displayStatus = 'bump';
	          this.selectOrder(order, order.displayStatus);
	
	          this.actionButton = 'bump';
	        }
	      } else {
	
	        if (!this.showReady) {
	          if (this.selectedOrder == order) {
	            this.deselectOrder(this.selectedOrder, 'prep');
	          } else {
	            if (this.selectedOrder && this.selectedOrder.checkdetails.chk_num) {
	              this.deselectOrder(this.selectedOrder, 'prep');
	            }
	
	            this.actionButton = 'bump';
	            this.selectOrder(order, 'ready');
	          }
	        } else {
	          if (this.selectedOrder == order && order.displayStatus == 'ready') {
	            order.displayStatus = 'bump';
	            this.selectOrder(order, order.displayStatus);
	
	            this.actionButton = 'bump';
	          } else if (this.selectedOrder == order && order.displayStatus == 'bump') {
	            order.displayStatus = 'prep';
	            this.deselectOrder(order, order.displayStatus);
	
	            this.actionButton = 'ready';
	          } else {
	            if (this.selectedOrder && this.selectedOrder.checkdetails.chk_num) {
	              this.deselectOrder(this.selectedOrder, 'prep');
	            }
	            order.displayStatus = 'ready';
	            this.selectOrder(order, order.displayStatus);
	
	            this.actionButton = 'ready';
	          }
	        }
	      }
	    },
	    selectOrder: function selectOrder(order, displayStatus) {
	      if (!order || !order.checkdetails) return;
	
	      this.setOrderDisplay(this.$refs['order' + order.checkdetails.chk_num][0], true, displayStatus);
	      this.selectedOrder = order;
	    },
	    deselectOrder: function deselectOrder(order, displayStatus) {
	      if (!order || !order.checkdetails) return;
	
	      if (!displayStatus) {
	        displayStatus = this.readyOrdersDisplay ? 'ready' : 'prep';
	      }
	
	      this.setOrderDisplay(this.$refs['order' + order.checkdetails.chk_num][0], false, displayStatus);
	      this.selectedOrder = null;
	    },
	    setOrderDisplay: function setOrderDisplay(panel, selected, displayStatus) {
	      if (!panel) return;
	
	      panel.classList.remove('prep', 'ready', 'bump', 'return', 'selected');
	
	      if (selected) {
	        panel.classList.add('selected');
	      }
	
	      if (displayStatus) {
	        if (!this.readyOrdersDisplay) {
	          if (displayStatus == 'ready') {
	            displayStatus = 'bump';
	          } else if (displayStatus == 'bump') {
	            displayStatus = 'ready';
	          }
	        }
	        panel.classList.add(displayStatus);
	      }
	    },
	    resetSize: function resetSize(orderInfo) {
	      try {
	        if (!this.detailView) return;
	
	        var COL_WIDTH = 180;
	
	        var orderPanel = this.$refs['order' + orderInfo.orderId][0];
	        var slidePanel = this.$refs['slide' + orderInfo.orderId][0];
	
	        var totalHeight = orderInfo.listContainer.scrollHeight;
	        var orderMainItems = orderInfo.listContainer.children;
	
	        var totalItemHeight = 0;
	        var c = 1;
	        for (var i = 0; i < orderMainItems.length; i++) {
	          totalItemHeight += orderMainItems[i].scrollHeight + 2;
	          if (totalItemHeight > totalHeight) {
	            c++;
	            totalItemHeight = orderMainItems[i].scrollHeight;
	          }
	        }
	
	        var h = window.innerHeight * 0.855;
	        var w = 82 + c * COL_WIDTH;
	
	        if (orderPanel) {
	          orderPanel.setAttribute('style', 'width:' + w + 'px; height:' + h + 'px; border: 4px solid;');
	        }
	        if (slidePanel) {
	          slidePanel.$el.setAttribute('style', 'width:' + w + 'px;');
	        }
	
	        this.$forceUpdate();
	      } catch (err) {}
	    },
	    startElapsedTime: function startElapsedTime() {
	      var _this5 = this;
	
	      if (this.elapsedTimeInterval) clearInterval(this.elapsedTimeInterval);
	      this.elapsedTimeInterval = setInterval(function () {
	        _this5.updateElapsedTime();
	      }, 1000);
	    },
	    updateElapsedTime: function updateElapsedTime() {
	      if (this.currentTime) {
	        this.currentTime.setSeconds(this.currentTime.getSeconds() + 1);
	
	        if (this.currentTime.getHours() == 4 && this.currentTime.getMinutes() == 30 && this.currentTime.getSeconds() == 0) {
	          this.reload();
	        }
	
	        if (this.orderList && this.orderList.length) {
	          this.elapsedTime = [];
	          for (var o = 0; o < this.orderList.length; o++) {
	            var sOrderTime = this.orderList[o].checkdetails[this.timeCheckField];
	            var dtOrderTime = _formatting2.default.dateFormat.dateFromStr(sOrderTime);
	            var oElapsedTime = _formatting2.default.dateFormat.calcElapsedTime(dtOrderTime, this.currentTime);
	
	            this.elapsedTime.push(oElapsedTime);
	          }
	        }
	      }
	    },
	    setDataPolling: function setDataPolling(flag, duration) {
	      var _this6 = this;
	
	      if (flag) {
	        if (this.pollingInterval) clearInterval(this.pollingInterval);
	        console.log('Setting polling interval to: ' + duration);
	        this.pollingInterval = setInterval(function () {
	          if (!_this6.actionInProgress) {
	            _this6.getOpenOrders();
	          }
	        }, duration || DEFAULT_POLLING_INTERVAL);
	      } else {
	        console.log('Stopped polling.');
	        if (this.pollingInterval) clearInterval(this.pollingInterval);
	      }
	    },
	    gotoKDSprep: function gotoKDSprep() {
	      var _this7 = this;
	
	      this.refreshDelay = false;
	      this.setDataPolling(false);
	
	      this.deselectOrder(this.selectedOrder, 'ready');
	
	      setTimeout(function () {
	        _this7.orderList = [];
	        _this7.init();
	      }, 200);
	
	      _router2.default.push('/kdsPrep');
	    },
	    gotoKDSready: function gotoKDSready() {
	      var _this8 = this;
	
	      this.refreshDelay = false;
	      this.setDataPolling(false);
	
	      this.deselectOrder(this.selectedOrder, 'prep');
	
	      setTimeout(function () {
	        _this8.orderList = [];
	        _this8.init();
	      }, 200);
	
	      _router2.default.push('/kdsReady');
	    },
	    gotoRecallList: function gotoRecallList() {
	
	      _router2.default.push('/recall');
	    },
	    reload: function reload() {
	      location.reload(true);
	    },
	    toggleDetailView: function toggleDetailView() {
	      this.detailView = !this.detailView;
	      _apiBridge2.default.kdsDetailView = this.detailView;
	
	      _apiBridge2.default.saveState();
	    },
	    init: function init(pollingInterval) {
	      var _this9 = this;
	
	      this.storeNumber = _apiBridge2.default.storeNumber;
	
	      if (_apiBridge2.default.language_flag === null) {
	        this.checkLanguage();
	      } else {
	        this.getOpenOrders();
	      }
	
	      if (this.selectedOrder) {
	        this.deselectOrder(this.selectedOrder);
	      }
	
	      this.showReady = _apiBridge2.default.brand == 'swiss' || _apiBridge2.default.appState.showReadyOverrideList.indexOf('' + _apiBridge2.default.storeNumber) >= 0;
	
	      if (this.readyOrdersDisplay) {
	        this.actionButton = 'bump';
	      } else if (!this.showReady) {
	        this.actionButton = 'bump';
	      } else {
	        this.actionButton = 'ready';
	      }
	
	      this.orderItemsHash = {};
	      this.setDataPolling(true, pollingInterval);
	
	      this.refreshDelay = false;
	      setTimeout(function () {
	        _this9.refreshDelay = true;
	        _this9.$forceUpdate();
	      }, 10000);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this10 = this;
	
	    console.log('KDS page');
	
	    document.body.style.backgroundColor = "#000";
	
	    _apiBridge2.default.getState();
	    _apiBridge2.default.setStore(_apiBridge2.default.storeNumber);
	
	    var storeId = (0, _utils.getQueryStringParameterByName)('storeId');
	    if (storeId) {
	      _apiBridge2.default.setStore(storeId);
	    }
	
	    if (_apiBridge2.default.storeSelected && _apiBridge2.default.storeNumber) {
	      (0, _utils.idFullStory)(_apiBridge2.default.storeNumber);
	
	      this.startElapsedTime();
	      this.init();
	    } else {
	      if (false) {
	        _router2.default.push('/login');
	      } else {
	        this.initInterval = setInterval(function () {
	          if (window.config && window.config.storeId) {
	
	            clearInterval(_this10.initInterval);
	
	            _apiBridge2.default.setStore(window.config.storeId);
	            _apiBridge2.default.setLanguage(window.config);
	            _apiBridge2.default.setProxy(window.config);
	
	            var pollingInterval = DEFAULT_POLLING_INTERVAL;
	
	            if (!_apiBridge2.default.useProxyApi && window.config.refreshRate) {
	              pollingInterval = 1000 * parseInt(window.config.refreshRate);
	            }
	
	            (0, _utils.idFullStory)(_apiBridge2.default.storeNumber);
	
	            _this10.startElapsedTime();
	            _this10.init(pollingInterval);
	          }
	        }, 500);
	      }
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    if (this.pollingInterval) clearInterval(this.pollingInterval);
	    if (this.initInterval) clearInterval(this.initInterval);
	  },
	  data: function data() {
	    return {
	      orderList: [],
	      pendingOrdersCall: false,
	      selectedOrder: null,
	      panelAnimation: [],
	      panelShrink: [],
	      panelFade: [],
	      elapsedTime: [],
	      actionButton: 'ready',
	      currentTime: null,
	      storeNumber: _apiBridge2.default.storeNumber,
	      showReady: false,
	      refreshDelay: false,
	      detailView: _apiBridge2.default.kdsDetailView,
	      swiperOption: {
	        slidesPerView: 'auto',
	        centeredSlides: false,
	        preventClicks: false,
	        preventClicksPropagation: false,
	        spaceBetween: 5,
	        allowTouchMove: false,
	        slideToClickedSlide: true,
	        pagination: {
	          el: '.swiper-pagination',
	          clickable: true,
	          type: 'progressbar'
	        },
	
	        navigation: {
	          nextEl: '.button-next',
	          prevEl: '.button-prev',
	          disabledClass: 'invisible',
	          hiddenClass: 'invisible'
	
	        }
	      },
	      swiperOptionDetailless: {
	        slidesPerView: 6,
	        slidesPerColumn: 3,
	        spaceBetween: 5,
	        direction: 'horizontal',
	        slidesPerColumnFill: 'column',
	        pagination: {
	          el: '.swiper-pagination',
	          clickable: true,
	          type: 'progressbar'
	        },
	        navigation: {
	          nextEl: '.button-next',
	          prevEl: '.button-prev',
	          disabledClass: 'invisible',
	          hiddenClass: 'invisible'
	        }
	      },
	      error: '...'
	    };
	  }
	};

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _buttonGroup = __webpack_require__(522);
	
	var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
	var _Radio = __webpack_require__(520);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'radio': _Radio2.default,
	    'buttonGroup': _buttonGroup2.default
	  },
	
	  methods: {
	    loginWithStoreNumber: function loginWithStoreNumber(landingScreen) {
	      var _this = this;
	
	      if (!this.storeNumber) {
	        this.$nextTick(function () {
	          _this.$refs.inStoreNumber.$el.focus();
	        });
	
	        return;
	      }
	
	      console.log('Login using Store: ' + this.storeNumber);
	
	      if (_apiBridge2.default.storeSelected) {
	        _apiBridge2.default.setEndpoint(_apiBridge2.default.mainAPIServer);
	        _apiBridge2.default.storeSelected = false;
	      }
	
	      if (_apiBridge2.default.checkOverride(this.storeNumber)) {
	        _apiBridge2.default.setStore(this.storeNumber);
	        _apiBridge2.default.buildEndpoint();
	      }
	
	      var self = this;
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getIsEnglish';
	      apiParameters.queryString['store_number'] = this.storeNumber;
	      apiParameters.queryString['login'] = 'true';
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        _apiBridge2.default.storeSelected = false;
	
	        if (_apiBridge2.default.useOverride) {
	          if (response.status != 200) {
	            self.error = self.$t('connection_error');
	            return;
	          }
	        } else if (!response.data || response.data.error || response.status != 200) {
	          if (response.errorMsg && response.errorMsg.response) {
	            if (response.errorMsg.response.data && response.errorMsg.response.data.error == 'no_data') {} else {
	              self.error = self.$t('connection_error');
	              return;
	            }
	          } else {
	            self.error = self.$t('no_internet');
	            return;
	          }
	        }
	
	        _apiBridge2.default.storeSelected = true;
	        _apiBridge2.default.setStore(self.storeNumber);
	
	        _apiBridge2.default.saveState();
	
	        if (landingScreen == 'G') {
	          _apiBridge2.default.station = 'gfb';
	        } else if (landingScreen == 'B') {
	          _apiBridge2.default.station = 'bin';
	        } else {
	          _apiBridge2.default.station = 'kds';
	
	          self.$parent.orderSoundPlay();
	        }
	
	        _router2.default.push('/main');
	      });
	    },
	    reload: function reload() {
	      location.reload(true);
	    }
	  },
	
	  mounted: function mounted() {
	    console.log('Login page');
	    document.body.style.backgroundColor = "#000";
	  },
	
	  data: function data() {
	    return {
	      storeNumber: null,
	      build: ("2022-09-06-t19"),
	      landingScreen: 'K',
	      error: ''
	    };
	  }
	};

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(94);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    gotoLogin: function gotoLogin() {
	      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logout) {
	        window.webkit.messageHandlers.logout.postMessage(null);
	      } else {
	        _apiBridge2.default.storeSelected = false;
	        _apiBridge2.default.storeNumber = null;
	        _apiBridge2.default.setStore(0);
	
	        _router2.default.push('/login');
	      }
	    },
	    gotoKDS: function gotoKDS() {
	      _router2.default.push('/kdsPrep');
	    },
	    gotoBin: function gotoBin() {
	      _router2.default.push('/kdsBin');
	    },
	    gotoGFB: function gotoGFB() {
	      _router2.default.push('/gfb');
	    },
	    init: function init() {
	      var _this = this;
	
	      var storeId = (0, _utils.getQueryStringParameterByName)('storeId');
	      if (storeId) {
	        _apiBridge2.default.setStore(storeId);
	      }
	
	      console.log((0, _stringify2.default)(_apiBridge2.default));
	
	      if (_apiBridge2.default.storeSelected && _apiBridge2.default.storeNumber) {
	
	        _apiBridge2.default.setStore(_apiBridge2.default.storeNumber);
	
	        if (_apiBridge2.default.station === 'gfb') {
	          this.gotoGFB();
	        } else if (_apiBridge2.default.station === 'bin') {
	          this.gotoBin();
	        } else {
	          this.gotoKDS();
	        }
	      } else {
	        if (false) {
	          this.gotoLogin();
	        } else {
	          this.initInterval = setInterval(function () {
	            if (window.config && window.config.storeId) {
	              clearInterval(_this.initInterval);
	
	              _apiBridge2.default.initFromConfig(window.config);
	
	              setTimeout(function () {
	                console.log((0, _stringify2.default)(_apiBridge2.default));
	              }, 2000);
	
	              if (_apiBridge2.default.station === 'bin') {
	                _this.gotoBin();
	              } else {
	                _this.gotoKDS();
	              }
	            }
	          }, 500);
	        }
	      }
	
	      setTimeout(function () {
	        _this.displayLogin = true;
	      }, 4000);
	    }
	  },
	
	  mounted: function mounted() {
	    console.log('Main page');
	    document.body.style.backgroundColor = "#000";
	
	    this.init();
	  },
	
	  data: function data() {
	    return {
	      displayLogin: false,
	      build: ("2022-09-06-t19")
	    };
	  }
	};

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'orderheader',
	
	  props: {
	    recallDisplay: {
	      type: Boolean,
	      default: false
	    },
	
	    checkNum: {
	      type: Number,
	      default: 0
	    },
	
	    revenueType: {
	      type: String,
	      default: ''
	    },
	
	    firstName: {
	      type: String,
	      default: ''
	    },
	
	    lastName: {
	      type: String,
	      default: ''
	    },
	
	    id: {
	      type: String,
	      default: ''
	    },
	
	    time: {
	      type: String,
	      default: ''
	    },
	
	    timeColour: {
	      type: String,
	      default: 'green'
	    },
	
	    postPay: {
	      type: Boolean,
	      default: false
	    },
	
	    closedDate: {
	      type: String,
	      default: ''
	    }
	
	  },
	
	  methods: {
	    displayHeader: function displayHeader(revenueType, lastName) {
	      if (lastName.substring(0, 4).toLowerCase() == revenueType.substring(0, 4).toLowerCase()) {
	        return revenueType;
	      } else {
	        return lastName + ' - ' + revenueType;
	      }
	    }
	  },
	
	  mounted: function mounted() {},
	
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXCLUSION_LIST = ['done', 'no thank-you', 'add', '. check #'];
	
	exports.default = {
	  name: 'orderitems',
	
	  props: {
	    passedItemList: {
	      type: Array,
	      default: null
	    },
	    orderId: {
	      type: Number,
	      default: 0
	    },
	    customerName: {
	      type: String,
	      default: ''
	    },
	    inGFB: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  methods: {
	    clearOrderItems: function clearOrderItems() {
	      this.itemList = [];
	      this.$forceUpdate();
	    },
	    setHidden: function setHidden(flag) {
	      if (flag === true) {
	        this.visibility = 'hidden';
	      } else {
	        this.visibility = 'visible';
	      }
	    },
	    overrideOrderItems: function overrideOrderItems(savedOrder) {
	      var _this = this;
	
	      console.log('Overriden Items loaded:' + savedOrder.orderId);
	      this.itemList = [];
	      this.visibility = 'hidden';
	      this.postPay = false;
	      this.$forceUpdate();
	
	      this.$nextTick(function () {
	        _this.itemList = savedOrder.items;
	        _this.orderTicket = savedOrder.orderTicket;
	        _this.postPay = savedOrder.postPay;
	
	        _this.$forceUpdate();
	        setTimeout(function () {
	          _this.updateOrder();
	          setTimeout(function () {
	            _this.visibility = 'visible';
	          }, 220);
	        }, 100);
	      });
	    },
	    getOrderItems: function getOrderItems(orderId) {
	      if (!orderId) orderId = this.orderId;
	      if (!orderId) return;
	
	      console.log('Getting items for order: ' + orderId);
	      this.visibility = 'hidden';
	
	      var self = this;
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getECommItems';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	      apiParameters.queryString['check_num'] = orderId;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        self.itemListRaw = response.data;
	        self.processItems(self.itemListRaw);
	      });
	    },
	    processItems: function processItems(items) {
	      var _this2 = this;
	
	      this.visibility = 'hidden';
	      this.postPay = false;
	
	      if (!items || !items.length) {
	        this.$emit('hideOrder', {
	          orderId: this.orderId
	        });
	        return;
	      }
	
	      var rootItems = [];
	      var subProducts = [];
	      var subItems = [];
	
	      for (var i = 0; i < items.length; i++) {
	        if ((items[i].item.Prefix == 'T' || items[i].item.dtl_name == 'Agg Chk#') && items[i + 1]) {
	          if (EXCLUSION_LIST.indexOf(('' + items[i].item.dtl_name).toLowerCase()) >= 0) {} else {
	            if (items[i + 1].item.ref) {
	              items[i + 1].item.dtl_name = ('' + items[i + 1].item.ref).trim();
	              items[i + 1].item.isCheckHeader = true;
	
	              if (items[i - 1]) {
	                items[i - 1].item.isCheckHeader = true;
	              }
	            } else if (EXCLUSION_LIST.indexOf(('' + items[i + 1].item.dtl_name).toLowerCase()) >= 0) {
	              items[i + 1].item.dtl_name = items[i].item.dtl_name;
	            } else {
	              items[i + 1].item.dtl_name = items[i].item.dtl_name + ' ' + items[i + 1].item.dtl_name;
	            }
	
	            this.refId = items[i + 1].item.dtl_name;
	          }
	        }
	
	        if (items[i].item.ref) {
	          var ref = ('' + items[i].item.ref).trim();
	
	          if (ref.indexOf('POST PAY') >= 0 || ref.indexOf('PAY@REST') >= 0 || ref.indexOf('CASH') >= 0) {
	
	            if (_apiBridge2.default.brand != 'harveys') {
	              this.postPay = true;
	            }
	          } else if (ref.indexOf('CANCELLED') >= 0) {
	            this.voided = true;
	          } else if (items[i].item.dtl_name == 'GUEST NAME') {
	            items[i].item.isCheckHeader = true;
	            items[i].item.dtl_name = this.$t('name') + ': ' + ref;
	            this.refId = ref;
	          }
	        }
	      }
	
	      for (var i = 0; i < items.length; i++) {
	        items[i] = items[i].item;
	
	        if (items[i].mi_obj_num == 1134 && items[i].ref.indexOf(' ') == 8) {
	          this.orderTicket = items[i].ref.replace(' ', '');
	        }
	
	        if (!items[i].dtl_name || items[i].Prefix == 'T' || EXCLUSION_LIST.indexOf(('' + items[i].dtl_name).toLowerCase()) >= 0) {} else {
	          if (items[i].parent_dtl_seq || items[i].combo_grp_seq) {
	            if (items[i].parent_dtl_seq) {
	              subItems.push(items[i]);
	            } else {
	              items[i].items = [];
	              subProducts.push(items[i]);
	            }
	          } else if (items[i].dtl_name) {
	            items[i].items = [];
	
	            rootItems.push(items[i]);
	
	            subProducts.push('break');
	          }
	        }
	      }
	
	      if (subItems.length) {
	        for (var s = 0; s < subItems.length; s++) {
	          for (var m = 0; m < rootItems.length; m++) {
	            if (subItems[s].parent_dtl_seq == rootItems[m].dtl_seq) {
	              rootItems[m].items.push(subItems[s]);
	            }
	          }
	
	          for (var p = 0; p < subProducts.length; p++) {
	            if (subItems[s].parent_dtl_seq == subProducts[p].dtl_seq && subItems[s].combo_grp_seq == subProducts[p].combo_grp_seq && subItems[s].dtl_id > subProducts[p].dtl_id) {
	              subProducts[p].items.push(subItems[s]);
	            }
	          }
	        }
	      }
	
	      if (subProducts.length) {
	        var m = -1;
	        for (var s = 0; s < subProducts.length; s++) {
	          if (subProducts[s] == 'break') {
	            m++;
	          } else if (rootItems[m] && rootItems[m].items) {
	            rootItems[m].items.push(subProducts[s]);
	          }
	        }
	      }
	
	      if (this.groupLikeItems) {
	        var collapsedRootItems = [];
	        for (var i = 0; i < rootItems.length; i++) {
	          if (rootItems[i].items && rootItems[i].items.length) {
	            if ([15, 97].indexOf(rootItems[i].print_grp) >= 0) {
	              for (var s = 0; s < rootItems[i].items.length; s++) {
	                rootItems[i].items[s].levels = 2;
	                collapsedRootItems.push(rootItems[i].items[s]);
	              }
	            } else {
	              rootItems[i].levels = 2;
	              collapsedRootItems.push(rootItems[i]);
	            }
	          } else {
	            rootItems[i].levels = 1;
	            collapsedRootItems.push(rootItems[i]);
	          }
	
	          if (rootItems[i].dtl_name == 'Agg Chk#') {
	            rootItems[i].isCheckHeader = true;
	            if (rootItems[i].levels == 1) {
	              rootItems[i].hidden = true;
	            }
	          }
	        }
	
	        collapsedRootItems.sort(function (a, b) {
	          if (b.isCheckHeader) return 1;
	          if (a.print_grp < b.print_grp) return 1;
	          if (a.print_grp > b.print_grp) return -1;
	          if (a.dtl_name > b.dtl_name) return 1;
	          if (a.dtl_name < b.dtl_name) return -1;
	
	          return 0;
	        });
	
	        this.itemList = collapsedRootItems;
	      } else {
	        for (var i = 0; i < rootItems.length; i++) {
	          var levels = 1;
	          if (rootItems[i].items && rootItems[i].items.length) {
	            levels = 2;
	            for (var s = 0; s < rootItems[i].items.length; s++) {
	              if (rootItems[i].items[s].items && rootItems[i].items[s].items.length) {
	                rootItems[i].items[s].items.sort(function (a, b) {
	                  if (a.print_grp > b.print_grp) return 1;
	                  if (a.print_grp < b.print_grp) return -1;
	                  return 0;
	                });
	
	                levels = 3;
	                break;
	              }
	            }
	          }
	          rootItems[i].levels = levels;
	
	          if (rootItems[i].dtl_name == 'Agg Chk#') {
	            rootItems[i].isCheckHeader = true;
	            if (rootItems[i].levels == 1) {
	              rootItems[i].hidden = true;
	            }
	          }
	        }
	        this.itemList = rootItems;
	      }
	
	      for (var i = 0; i < this.itemList.length; i++) {
	        if (this.itemList[i].items && this.itemList[i].items.length) {
	          this.itemList[i].items.sort(function (a, b) {
	            if (a.print_grp > b.print_grp) return 1;
	            if (a.print_grp < b.print_grp) return -1;
	            return 0;
	          });
	        }
	      }
	
	      this.$forceUpdate();
	
	      this.$nextTick(function () {
	        _this2.updateOrder(true);
	      });
	    },
	    updateOrder: function updateOrder(updateHash) {
	      var _this3 = this;
	
	      this.visibility = 'hidden';
	      if (this.$refs.listContainer) {
	        this.$emit('updateOrder', {
	          orderId: this.orderId,
	          orderTicket: this.orderTicket || null,
	          refId: this.refId || null,
	          postPay: this.postPay || false,
	          voided: this.voided || false,
	          processedItems: this.itemList,
	          listContainer: this.$refs.listContainer,
	          updateHash: updateHash || false
	        });
	      }
	      setTimeout(function () {
	        _this3.visibility = 'visible';
	      }, 220);
	    },
	    checkItemDisplay: function checkItemDisplay(item) {
	      if (item.hidden) {
	        return false;
	      }
	
	      return true;
	    },
	    calcFontSize: function calcFontSize(item) {
	      if (item.levels < 3 && !item.isCheckHeader) {
	        return 'font-size: small;';
	      }
	      return '';
	    },
	    checkHeader: function checkHeader(item) {
	      if (item.isCheckHeader) {
	        return 'border: solid green 1px; padding: 5px 15px;';
	      }
	      return '';
	    },
	    init: function init() {
	      if (this.passedItemList && this.passedItemList.length) {
	        this.itemListRaw = this.passedItemList;
	        this.processItems(this.itemListRaw);
	      } else if (this.orderId) {}
	    }
	  },
	
	  mounted: function mounted() {
	    console.log('order items');
	
	    this.init();
	  },
	
	  data: function data() {
	    return {
	      groupLikeItems: true,
	      itemListRaw: [],
	      itemList: [],
	      visibility: 'visible',
	      refId: '',
	      postPay: false,
	      language: _apiBridge2.default.language,
	      error: ''
	    };
	  }
	};

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _formatting = __webpack_require__(62);
	
	var _formatting2 = _interopRequireDefault(_formatting);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _OrderHeader = __webpack_require__(136);
	
	var _OrderHeader2 = _interopRequireDefault(_OrderHeader);
	
	var _OrderItems = __webpack_require__(137);
	
	var _OrderItems2 = _interopRequireDefault(_OrderItems);
	
	__webpack_require__(135);
	
	var _vueAwesomeSwiper = __webpack_require__(92);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'recall',
	
	  components: {
	    'orderheader': _OrderHeader2.default,
	    'orderitems': _OrderItems2.default,
	    'swiper': _vueAwesomeSwiper.swiper,
	    'slide': _vueAwesomeSwiper.swiperSlide
	  },
	
	  created: function created() {},
	
	  methods: {
	    getRecallList: function getRecallList() {
	      console.log('Get recall list');
	      var self = this;
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getRecallList';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        if (response.nativeError == 'connection_error') {
	          self.error = self.$t('connection_error');
	          return;
	        }
	
	        var orderListRaw = response.data;
	        self.orderList = [];
	
	        if (orderListRaw && orderListRaw.length) {
	          self.currentTime = orderListRaw[0].checkdetails.Curr_DT ? _formatting2.default.dateFormat.dateFromStr(orderListRaw[0].checkdetails.Curr_DT) : null;
	
	          orderListRaw = orderListRaw.filter(self.filterOutOrder);
	
	          var alreadyThere = false;
	          for (var r = 0; r < orderListRaw.length; r++) {
	            alreadyThere = false;
	            for (var o = 0; o < self.orderList.length; o++) {
	              if (orderListRaw[r].checkdetails.chk_num == self.orderList[o].checkdetails.chk_num) {
	                alreadyThere = true;
	
	                if (orderListRaw[r].checkdetails.last_update_tm > self.orderList[o].checkdetails.last_update_tm || orderListRaw[r].checkdetails.trans_seq > self.orderList[o].checkdetails.trans_seq) {
	                  self.orderList[o] = orderListRaw[r];
	                }
	              }
	            }
	
	            if (!alreadyThere) {
	              self.orderList.push(orderListRaw[r]);
	            }
	          }
	        }
	
	        if (!self.orderList || !self.orderList.length) {}
	
	        self.orderList.sort(function (a, b) {
	          var dta = _formatting2.default.dateFormat.dateFromStr(a.checkdetails.bumpTime);
	          var dtb = _formatting2.default.dateFormat.dateFromStr(b.checkdetails.bumpTime);
	
	          if (dta > dtb) return -1;
	          if (dta < dtb) return 1;
	          return 0;
	        });
	
	        if (self.orderList && self.orderList.length) {
	          self.orderList = self.orderList.slice(0, 40);
	
	          for (var _o = 0; _o < self.orderList.length; _o++) {
	            self.panelAnimation.push(true);
	            self.panelShrink.push(false);
	            self.panelFade.push(false);
	
	            var orderTime = _formatting2.default.dateFormat.dateFromStr(self.orderList[_o].checkdetails.bumpTime);
	            self.orderList[_o].checkdetails.displayTime = _formatting2.default.dateFormat.timeHMampm(orderTime);
	
	            var timeDiff = _formatting2.default.dateFormat.calcDiffInMinutes(self.currentTime, orderTime);
	            if (timeDiff >= 120) {
	              self.orderList[_o].checkdetails.timeColour = '#FF0000';
	            } else if (timeDiff >= 60) {
	              self.orderList[_o].checkdetails.timeColour = '#FF8C00';
	            } else {
	              self.orderList[_o].checkdetails.timeColour = '#008000';
	            }
	          }
	        }
	
	        self.refreshDelay = true;
	        self.$forceUpdate();
	      });
	    },
	    filterOutOrder: function filterOutOrder(order) {
	      var excludeList = _apiBridge2.default.appState.orderChannelExclusionList;
	      if (excludeList && excludeList.length) {
	        for (var e = 0; e < excludeList.length; e++) {
	          if ((0, _utils.checkFilterCriteria)(excludeList[e].channel, order.checkdetails.last_name) && (0, _utils.checkFilterCriteria)(excludeList[e].type, order.checkdetails.name)) {
	            return false;
	          }
	
	          if ((0, _utils.checkFilterCriteria)(excludeList[e].emp_num, order.checkdetails.emp_num) && (0, _utils.checkFilterCriteria)(excludeList[e].type, order.checkdetails.name)) {
	
	            return false;
	          }
	        }
	      }
	
	      return true;
	    },
	    recallOrder: function recallOrder(orderId, resultCallback) {
	      console.log('Recall order:' + orderId);
	
	      var apiParameters = {};
	      apiParameters.queryString = {};
	
	      apiParameters.service = 'getRecallCheck';
	      apiParameters.queryString['store_number'] = _apiBridge2.default.storeNumber;
	      apiParameters.queryString['check_num'] = orderId;
	
	      _apiBridge2.default.httpGet(apiParameters, function (response) {
	        if (typeof resultCallback === "function") {
	          resultCallback(response);
	        }
	      });
	    },
	    recallLaunch: function recallLaunch() {
	      if (!this.selectedOrder) return;
	
	      var self = this;
	      this.recallOrder(this.selectedOrder.order.checkdetails.chk_num, function (response) {
	        if (!response || response.data != 99) {
	          console.log('Bump api call failed for order:');
	          return;
	        }
	
	        var index = self.orderList.indexOf(self.selectedOrder.order);
	
	        self.panelShrink[index] = true;
	        self.$forceUpdate();
	
	        setTimeout(function () {
	          self.panelFade[index] = true;
	          self.$forceUpdate();
	        }, 400);
	
	        setTimeout(function () {
	          self.panelAnimation[index] = false;
	          self.recallFinish();
	        }, 800);
	      });
	    },
	    recallFinish: function recallFinish() {
	      var _this = this;
	
	      if (this.selectedOrder) {
	        this.orderList.splice(this.orderList.indexOf(this.selectedOrder.order), 1);
	      }
	      this.selectedOrder = null;
	      this.$forceUpdate();
	
	      this.$nextTick(function () {
	        _this.panelAnimation = [];
	        _this.panelShrink = [];
	        _this.panelFade = [];
	
	        _this.orderList.forEach(function (order) {
	          _this.panelAnimation.push(false);
	          _this.panelShrink.push(false);
	          _this.panelFade.push(false);
	        });
	
	        _this.$forceUpdate();
	      });
	
	      setTimeout(function () {
	        for (var i = 0; i < _this.panelAnimation.length; i++) {
	          _this.panelAnimation[i] = true;
	        }
	
	        _this.$forceUpdate();
	      }, 400);
	    },
	    toggleOrderSelect: function toggleOrderSelect(el, order) {
	      var _this2 = this;
	
	      console.log('toggle order');
	
	      var _loop = function _loop(e) {
	        if (el.path[e].className.indexOf('panel-default') >= 0) {
	          if (_this2.selectedOrder && _this2.selectedOrder.el == el.path[e]) {
	            _this2.setBorder(_this2.selectedOrder.el, false);
	            setTimeout(function () {
	              _this2.deselectOrder(el.path[e]);
	            }, 300);
	          } else {
	            _this2.setBorder(el.path[e], true);
	            if (_this2.selectedOrder) {
	              _this2.setBorder(_this2.selectedOrder.el, false);
	            }
	            setTimeout(function () {
	              _this2.selectedOrder = { el: el.path[e], order: order };
	            }, 300);
	          }
	
	          _this2.selectedOrder = null;
	
	
	          return 'break';
	        }
	      };
	
	      for (var e = 0; e < el.path.length; e++) {
	        var _ret = _loop(e);
	
	        if (_ret === 'break') break;
	      }
	    },
	    deselectOrder: function deselectOrder(el) {
	      var del = el;
	      if (!del && this.selectedOrder) {
	        del = this.selectedOrder.el;
	      }
	
	      if (!del) {
	        return;
	      }
	
	      this.setBorder(del, false);
	      this.selectedOrder = null;
	    },
	    setBorder: function setBorder(panel, selected) {
	      if (selected) {
	
	        panel.classList.add("selected");
	      } else {
	
	        panel.classList.remove("selected");
	      }
	    },
	    gotoMain: function gotoMain() {
	      _router2.default.push('/main');
	    },
	    gotoInfo: function gotoInfo() {
	      _router2.default.push('/info');
	    },
	    reload: function reload() {
	      location.reload(true);
	    },
	    init: function init() {
	      var _this3 = this;
	
	      if (!_apiBridge2.default.storeSelected) {
	        _router2.default.push('/login');
	      }
	      this.getRecallList();
	
	      setTimeout(function () {
	        _this3.logoutTimeout = false;
	      }, 2000);
	
	      this.refreshDelay = false;
	      setTimeout(function () {
	        _this3.refreshDelay = true;
	        _this3.$forceUpdate();
	      }, 20000);
	    }
	  },
	
	  mounted: function mounted() {
	    console.log('Main page');
	    document.body.style.backgroundColor = "#000";
	
	    this.init();
	  },
	
	  data: function data() {
	    return {
	      orderList: [],
	      selectedOrder: null,
	      panelAnimation: [],
	      panelShrink: [],
	      panelFade: [],
	      logoutTimeout: true,
	      build: ("2022-09-06-t19"),
	      storeNumber: _apiBridge2.default.storeNumber,
	      refreshDelay: false,
	      swiperOption: {
	        slidesPerView: 6,
	        slidesPerColumn: 3,
	        spaceBetween: 5,
	        direction: 'horizontal',
	        slidesPerColumnFill: 'column',
	        pagination: {
	          el: '.swiper-pagination',
	          clickable: true,
	          type: 'progressbar'
	        },
	        navigation: {
	          nextEl: '.button-next',
	          prevEl: '.button-prev',
	          disabledClass: 'invisible',
	          hiddenClass: 'invisible'
	        }
	      },
	      error: ''
	    };
	  }
	};

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NodeList = __webpack_require__(147);
	
	var _NodeList2 = _interopRequireDefault(_NodeList);
	
	var _ClickOutside = __webpack_require__(240);
	
	var _ClickOutside2 = _interopRequireDefault(_ClickOutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  directives: {
	    ClickOutside: _ClickOutside2.default
	  },
	  props: {
	    disabled: { type: Boolean, default: false },
	    size: { type: String, default: null },
	    text: { type: String, default: null },
	    type: { type: String, default: 'default' },
	    value: { type: Boolean, default: false }
	  },
	  data: function data() {
	    var show = this.value;
	    return { show: show };
	  },
	
	  watch: {
	    show: function show(val) {
	      this.$emit('input', val);
	    },
	    value: function value(val) {
	      this.show = val;
	    }
	  },
	  computed: {
	    buttonSize: function buttonSize() {
	      return ~['lg', 'sm', 'xs'].indexOf(this.size) ? 'btn-' + this.size : '';
	    },
	    inInput: function inInput() {
	      return this.$parent._input;
	    },
	    isLi: function isLi() {
	      return this.$parent._isTabs || this.$parent._navbar || this.$parent.menu;
	    },
	    menu: function menu() {
	      return !this.$parent || this.$parent.navbar;
	    },
	    slots: function slots() {
	      return this._slotContents;
	    },
	    submenu: function submenu() {
	      return this.$parent && (this.$parent.menu || this.$parent.submenu);
	    }
	  },
	  methods: {
	    blur: function blur() {
	      this.show = false;
	    },
	    toggle: function toggle() {
	      if (!this.disabled) {
	        this.show = !this.show;
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    (0, _NodeList2.default)('ul', this.$el).on('click', 'li>a', function (e) {
	      _this.show = false;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    (0, _NodeList2.default)('ul', this.$el).off();
	  }
	};

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NodeList = __webpack_require__(147);
	
	var _NodeList2 = _interopRequireDefault(_NodeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    type: { type: String, default: 'default' },
	    placement: { type: String, default: '' }
	  },
	  data: function data() {
	    return {
	      id: 'bs-example-navbar-collapse-1',
	      collapsed: true,
	      styles: {}
	    };
	  },
	
	  computed: {
	    slots: function slots() {
	      return this._slotContents;
	    }
	  },
	  methods: {
	    toggleCollapse: function toggleCollapse(e) {
	      e && e.preventDefault();
	      this.collapsed = !this.collapsed;
	    }
	  },
	  created: function created() {
	    this._navbar = true;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    try {
	      var $dropdown = (0, _NodeList2.default)('.dropdown>[data-toggle="dropdown"]', this.$el).parent();
	      if ($dropdown) {
	        $dropdown.on('click', '.dropdown-toggle', function (e) {
	          e.preventDefault();
	          $dropdown.each(function (content) {
	            if (content.contains(e.target)) content.classList.toggle('open');
	          });
	        }).on('click', '.dropdown-menu>li>a', function (e) {
	          $dropdown.each(function (content) {
	            if (content.contains(e.target)) content.classList.remove('open');
	          });
	        }).onBlur(function (e) {
	          $dropdown.each(function (content) {
	            if (!content.contains(e.target)) content.classList.remove('open');
	          });
	        });
	      }
	    } catch (ex) {
	      console.log('error finding dropdown');
	    }
	
	    (0, _NodeList2.default)(this.$el).on('click touchstart', 'li:not(.dropdown)>a', function (e) {
	      setTimeout(function () {
	        _this.collapsed = true;
	      }, 200);
	    }).onBlur(function (e) {
	      if (!_this.$el.contains(e.target)) {
	        _this.collapsed = true;
	      }
	    });
	    var height = this.$el.offsetHeight;
	    if (this.placement === 'top') {
	      document.body.style.paddingTop = height + 'px';
	    }
	    if (this.placement === 'bottom') {
	      document.body.style.paddingBottom = height + 'px';
	    }
	    if (this.$slots.collapse) (0, _NodeList2.default)('[data-toggle="collapse"]', this.$el).on('click', function (e) {
	      return _this.toggleCollapse(e);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    (0, _NodeList2.default)('.dropdown', this.$el).off('click').offBlur();
	    if (this.$slots.collapse) (0, _NodeList2.default)('[data-toggle="collapse"]', this.$el).off('click');
	  }
	};

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    button: { type: Boolean, default: false },
	    checkedValue: { default: true },
	    disabled: { type: Boolean, default: false },
	    name: { type: String, default: null },
	    readonly: { type: Boolean, default: false },
	    type: { type: String, default: null },
	    value: { default: false }
	  },
	  data: function data() {
	    return {
	      check: this.value
	    };
	  },
	
	  computed: {
	    active: function active() {
	      return this.check === this.checkedValue;
	    },
	    parentValue: function parentValue() {
	      return this._inGroup ? this.$parent.val === this.value : null;
	    },
	    buttonStyle: function buttonStyle() {
	      return this.button || this._inGroup && this.$parent.buttons;
	    },
	    typeColor: function typeColor() {
	      return this.type || this.$parent && this.$parent.type || 'default';
	    }
	  },
	  watch: {
	    check: function check(val) {
	      if (this.checkedValue === val) {
	        this.$emit('input', val);
	        this.$emit('checked', true);
	        if (this._inGroup) {
	          this.$parent.val = val;
	        }
	      }
	    },
	    parentValue: function parentValue(val) {
	      if (this.check !== val && this.checkedValue === val) {
	        this.check = val;
	      }
	    },
	    value: function value(val) {
	      this.check = this.checkedValue === val ? val : null;
	    }
	  },
	  created: function created() {
	    var parent = this.$parent;
	    if (parent && parent._btnGroup && !parent._checkboxGroup) {
	      this._inGroup = true;
	      parent._radioGroup = true;
	    }
	    if (this.$parent._radioGroup) {
	      if (this.$parent.val) {
	        this.check = this.$parent.val === this.checkedValue;
	      } else if (this.check) {
	        this.$parent.val = this.checkedValue;
	      }
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.$refs.input.focus();
	    },
	    toggle: function toggle() {
	      if (this.disabled) {
	        return;
	      }
	      this.focus();
	      if (this.readonly) {
	        return;
	      }
	      this.check = this.checkedValue;
	      if (this._inGroup) {
	        this.$parent.val = this.checkedValue;
	      }
	    }
	  }
	};

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(242);
	
	var MIN_WAIT = 500;exports.default = {
	  props: {
	    fixed: { type: Boolean, default: false },
	    global: { type: Boolean, default: false },
	    size: { type: String, default: 'md' },
	    text: { type: String, default: '' },
	    value: { default: false }
	  },
	  data: function data() {
	    return {
	      active: this.value,
	      locked: false
	    };
	  },
	
	  computed: {
	    spinnerSize: function spinnerSize() {
	      return 'spinner-' + (this.size ? this.size : 'sm');
	    }
	  },
	  watch: {
	    active: function active(val, old) {
	      if (val !== old) this.$emit('input', val);
	    },
	    value: function value(val, old) {
	      if (val !== old) {
	        this[val ? 'show' : 'hide']();
	      }
	    }
	  },
	  methods: {
	    hide: function hide() {
	      var delay = 0;
	      this.active = false;
	    },
	    show: function show(options) {
	      if (options) {
	        if (options.text) {
	          this.text = options.text;
	        }
	        if (options.size) {
	          this.size = options.size;
	        }
	        if (options.fixed) {
	          this.fixed = options.fixed;
	        }
	      }
	
	      this._body.style.overflowY = 'hidden';
	
	      this._started = new Date();
	      this.active = true;
	      this.locked = true;
	      this._unlock();
	    }
	  },
	  created: function created() {
	    this._body = document.body;
	    this._bodyOverflow = document.body.style.overflowY;
	    this._unlock = (0, _utils.delayer)(function () {
	      this.locked = false;
	      this._body.style.overflowY = this._bodyOverflow;
	    }, MIN_WAIT);
	    if (this.global) {
	      if (!this.$root._globalSpinner) {
	        this.$root._globalSpinner = true;
	        var self = this;
	        this._global = {
	          hide: function hide() {
	            self.hide();
	          },
	          show: function show() {
	            self.show();
	          }
	        };
	        this.$root.$on('spinner::show', this._global.show);
	        this.$root.$on('spinner::hide', this._global.hide);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._global) {
	      this.$root.$off('spinner::show', this._global.show);
	      this.$root.$off('spinner::hide', this._global.hide);
	      delete this.$root._globalSpinner;
	    }
	    clearTimeout(this._spinnerAnimation);
	    this._body.style.overflowY = this._bodyOverflow;
	  }
	};

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    buttons: { default: true },
	    justified: { type: Boolean, default: false },
	    type: { type: String, default: 'default' },
	    value: { default: null },
	    vertical: { type: Boolean, default: false }
	  },
	  data: function data() {
	    this._btnGroup = true;
	    return {
	      val: this.value
	    };
	  },
	
	  watch: {
	    val: function val(_val) {
	      this.$emit('input', _val);
	    }
	  }
	};

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(94);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOCAL_STORAGE_KEY = 'KDS';
	var AUTO_BUMP_MINUTES = 15;
	
	exports.default = {
	  defaultAppState: function defaultAppState() {
	    return {
	      pushNotificationList: [],
	      autoBumpMinutes: AUTO_BUMP_MINUTES,
	      kdsDetailView: true
	    };
	  },
	  saveStateCookie: function saveStateCookie(data) {
	    var d = new Date();
	    d.setTime(d.getTime() + 100 * 24 * 60 * 60 * 1000);
	    var expires = 'expires=' + d.toUTCString();
	    document.cookie = LOCAL_STORAGE_KEY + '=' + (0, _stringify2.default)(data) + ';' + expires + ';path=/';
	  },
	  getStateCookie: function getStateCookie() {
	    var result = document.cookie.match(new RegExp(LOCAL_STORAGE_KEY + '=([^;]+)'));
	    result && (result = JSON.parse(result[1]));
	    return result;
	  },
	  deleteStateCookie: function deleteStateCookie() {
	    document.cookie = [LOCAL_STORAGE_KEY, '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/; domain=.', window.location.host.toString()].join('');
	  },
	  setLocalStorage: function setLocalStorage(data) {
	    console.log('set local storage: ' + LOCAL_STORAGE_KEY);
	
	    if (typeof Storage !== "undefined") {
	      try {
	        var strData = (0, _stringify2.default)(data);
	        window.localStorage.setItem(LOCAL_STORAGE_KEY, strData);
	      } catch (e) {
	        return false;
	      }
	    } else {
	      return false;
	    }
	  },
	  getLocalStorage: function getLocalStorage() {
	    console.log('get local storage');
	    if (typeof Storage !== "undefined") {
	      try {
	        var strData = window.localStorage.getItem(LOCAL_STORAGE_KEY);
	        var data = JSON.parse(strData);
	        return data;
	      } catch (e) {
	        return null;
	      }
	    } else {
	      return null;
	    }
	  },
	  clearLocalStorage: function clearLocalStorage() {
	    if (typeof Storage !== "undefined") {
	      console.log('clear local storage: ' + LOCAL_STORAGE_KEY);
	      window.localStorage.removeItem(LOCAL_STORAGE_KEY);
	    }
	  }
	};

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var binded = [];
	
	function handler(e) {
	  binded.forEach(function (el) {
	    if (!el.node.contains(e.target)) el.callback(e);
	  });
	}
	
	function addListener(node, callback) {
	  if (!binded.length) document.addEventListener('click', handler, false);
	  binded.push({ node: node, callback: callback });
	}
	
	function removeListener(node, callback) {
	  binded = binded.filter(function (el) {
	    return el.node !== node ? true : !callback ? false : el.callback !== callback;
	  });
	  if (!binded.length) document.removeEventListener('click', handler, false);
	}
	
	exports.default = {
	  bind: function bind(el, binding) {
	    removeListener(el, binding.value);
	    if (typeof binding.value !== 'function') {
	      if (false) {
	        Vue.util.warn('ClickOutside only work with a function, received: v-' + binding.name + '="' + binding.expression + '"');
	      }
	    } else {
	      addListener(el, binding.value);
	    }
	  },
	  update: function update(el, binding) {
	    if (binding.value !== binding.oldValue) {
	      removeListener(el, binding.oldValue);
	      addListener(el, binding.value);
	    }
	  },
	  unbind: function unbind(el, binding) {
	    removeListener(el, binding.value);
	  }
	};

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	'use strict';
	
	if (!Array.prototype.find) {
	  Array.prototype.find = function (predicate) {
	    'use strict';
	
	    if (this == null) {
	      throw new TypeError('Array.prototype.find called on null or undefined');
	    }
	    if (typeof predicate !== 'function') {
	      throw new TypeError('predicate must be a function');
	    }
	    var list = Object(this);
	    var length = list.length >>> 0;
	    var thisArg = arguments[1];
	    var value;
	
	    for (var i = 0; i < length; i++) {
	      value = list[i];
	      if (predicate.call(thisArg, value, i, list)) {
	        return value;
	      }
	    }
	    return undefined;
	  };
	}
	
	if (typeof window !== 'undefined') {
	  if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {
	
	    (function (view) {
	
	      "use strict";
	
	      if (!('Element' in view)) return;
	
	      var classListProp = "classList",
	          protoProp = "prototype",
	          elemCtrProto = view.Element[protoProp],
	          objCtr = Object,
	          strTrim = String[protoProp].trim || function () {
	        return this.replace(/^\s+|\s+$/g, "");
	      },
	          arrIndexOf = Array[protoProp].indexOf || function (item) {
	        var i = 0,
	            len = this.length;
	        for (; i < len; i++) {
	          if (i in this && this[i] === item) {
	            return i;
	          }
	        }
	        return -1;
	      },
	          DOMEx = function DOMEx(type, message) {
	        this.name = type;
	        this.code = DOMException[type];
	        this.message = message;
	      },
	          checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
	        if (token === "") {
	          throw new DOMEx("SYNTAX_ERR", "An invalid or illegal string was specified");
	        }
	        if (/\s/.test(token)) {
	          throw new DOMEx("INVALID_CHARACTER_ERR", "String contains an invalid character");
	        }
	        return arrIndexOf.call(classList, token);
	      },
	          ClassList = function ClassList(elem) {
	        var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
	            classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
	            i = 0,
	            len = classes.length;
	        for (; i < len; i++) {
	          this.push(classes[i]);
	        }
	        this._updateClassName = function () {
	          elem.setAttribute("class", this.toString());
	        };
	      },
	          classListProto = ClassList[protoProp] = [],
	          classListGetter = function classListGetter() {
	        return new ClassList(this);
	      };
	
	      DOMEx[protoProp] = Error[protoProp];
	      classListProto.item = function (i) {
	        return this[i] || null;
	      };
	      classListProto.contains = function (token) {
	        token += "";
	        return checkTokenAndGetIndex(this, token) !== -1;
	      };
	      classListProto.add = function () {
	        var tokens = arguments,
	            i = 0,
	            l = tokens.length,
	            token,
	            updated = false;
	        do {
	          token = tokens[i] + "";
	          if (checkTokenAndGetIndex(this, token) === -1) {
	            this.push(token);
	            updated = true;
	          }
	        } while (++i < l);
	
	        if (updated) {
	          this._updateClassName();
	        }
	      };
	      classListProto.remove = function () {
	        var tokens = arguments,
	            i = 0,
	            l = tokens.length,
	            token,
	            updated = false,
	            index;
	        do {
	          token = tokens[i] + "";
	          index = checkTokenAndGetIndex(this, token);
	          while (index !== -1) {
	            this.splice(index, 1);
	            updated = true;
	            index = checkTokenAndGetIndex(this, token);
	          }
	        } while (++i < l);
	
	        if (updated) {
	          this._updateClassName();
	        }
	      };
	      classListProto.toggle = function (token, force) {
	        token += "";
	
	        var result = this.contains(token),
	            method = result ? force !== true && "remove" : force !== false && "add";
	
	        if (method) {
	          this[method](token);
	        }
	
	        if (force === true || force === false) {
	          return force;
	        } else {
	          return !result;
	        }
	      };
	      classListProto.toString = function () {
	        return this.join(" ");
	      };
	
	      if (objCtr.defineProperty) {
	        var classListPropDesc = {
	          get: classListGetter,
	          enumerable: true,
	          configurable: true
	        };
	        try {
	          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	        } catch (ex) {
	          if (ex.number === -0x7FF5EC54) {
	            classListPropDesc.enumerable = false;
	            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	          }
	        }
	      } else if (objCtr[protoProp].__defineGetter__) {
	        elemCtrProto.__defineGetter__(classListProp, classListGetter);
	      }
	    })(self);
	  } else {
	
	    (function () {
	      "use strict";
	
	      var testElement = document.createElement("_");
	
	      testElement.classList.add("c1", "c2");
	
	      if (!testElement.classList.contains("c2")) {
	        var createMethod = function createMethod(method) {
	          var original = DOMTokenList.prototype[method];
	
	          DOMTokenList.prototype[method] = function (token) {
	            var i,
	                len = arguments.length;
	
	            for (i = 0; i < len; i++) {
	              token = arguments[i];
	              original.call(this, token);
	            }
	          };
	        };
	        createMethod('add');
	        createMethod('remove');
	      }
	
	      testElement.classList.toggle("c3", false);
	
	      if (testElement.classList.contains("c3")) {
	        var _toggle = DOMTokenList.prototype.toggle;
	
	        DOMTokenList.prototype.toggle = function (token, force) {
	          if (1 in arguments && !this.contains(token) === !force) {
	            return force;
	          } else {
	            return _toggle.call(this, token);
	          }
	        };
	      }
	
	      testElement = null;
	    })();
	  }
	}

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getJSON = getJSON;
	exports.getScrollBarWidth = getScrollBarWidth;
	exports.translations = translations;
	exports.delayer = delayer;
	exports.VueFixer = VueFixer;
	var coerce = exports.coerce = {
	  boolean: function boolean(val) {
	    return typeof val === 'string' ? val === '' || val === 'true' ? true : val === 'false' || val === 'null' || val === 'undefined' ? false : val : val;
	  },
	
	  number: function number(val) {
	    var alt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    return typeof val === 'number' ? val : val === undefined || val === null || isNaN(Number(val)) ? alt : Number(val);
	  },
	
	  string: function string(val) {
	    return val === undefined || val === null ? '' : val + '';
	  },
	
	  pattern: function pattern(val) {
	    return val instanceof Function || val instanceof RegExp ? val : typeof val === 'string' ? new RegExp(val) : null;
	  }
	};
	
	function getJSON(url) {
	  var request = new window.XMLHttpRequest();
	  var data = {};
	
	  var p = {
	    then: function then(fn1, fn2) {
	      return p.done(fn1).fail(fn2);
	    },
	    catch: function _catch(fn) {
	      return p.fail(fn);
	    },
	    always: function always(fn) {
	      return p.done(fn).fail(fn);
	    }
	  };
	  ['done', 'fail'].forEach(function (name) {
	    data[name] = [];
	    p[name] = function (fn) {
	      if (fn instanceof Function) data[name].push(fn);
	      return p;
	    };
	  });
	  p.done(JSON.parse);
	  request.onreadystatechange = function () {
	    if (request.readyState === 4) {
	      var e = { status: request.status };
	      if (request.status === 200) {
	        try {
	          var response = request.responseText;
	          for (var i in data.done) {
	            var value = data.done[i](response);
	            if (value !== undefined) {
	              response = value;
	            }
	          }
	        } catch (err) {
	          data.fail.forEach(function (fail) {
	            return fail(err);
	          });
	        }
	      } else {
	        data.fail.forEach(function (fail) {
	          return fail(e);
	        });
	      }
	    }
	  };
	  request.open('GET', url);
	  request.setRequestHeader('Accept', 'application/json');
	  request.send();
	  return p;
	}
	
	function getScrollBarWidth() {
	  if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
	    return 0;
	  }
	  var inner = document.createElement('p');
	  inner.style.width = '100%';
	  inner.style.height = '200px';
	
	  var outer = document.createElement('div');
	  outer.style.position = 'absolute';
	  outer.style.top = '0px';
	  outer.style.left = '0px';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '200px';
	  outer.style.height = '150px';
	  outer.style.overflow = 'hidden';
	  outer.appendChild(inner);
	
	  document.body.appendChild(outer);
	  var w1 = inner.offsetWidth;
	  outer.style.overflow = 'scroll';
	  var w2 = inner.offsetWidth;
	  if (w1 === w2) w2 = outer.clientWidth;
	
	  document.body.removeChild(outer);
	
	  return w1 - w2;
	}
	
	function translations() {
	  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	
	  var text = {
	    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	    limit: 'Limit reached ({{limit}} items max).',
	    loading: 'Loading...',
	    minLength: 'Min. Length',
	    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    notSelected: 'Nothing Selected',
	    required: 'Required',
	    search: 'Search'
	  };
	  return typeof window !== 'undefined' && window.VueStrapLang ? window.VueStrapLang(lang) : text;
	}
	
	function delayer(fn, varTimer) {
	  var ifNaN = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
	
	  function toInt(el) {
	    return (/^[0-9]+$/.test(el) ? Number(el) || 1 : null
	    );
	  }
	  var timerId;
	  return function () {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (timerId) clearTimeout(timerId);
	    timerId = setTimeout(function () {
	      fn.apply(_this, args);
	    }, toInt(varTimer) || toInt(this[varTimer]) || ifNaN);
	  };
	}
	
	function VueFixer(vue) {
	  var vue2 = !window.Vue || !window.Vue.partial;
	  var mixin = {
	    computed: {
	      vue2: function vue2() {
	        return !this.$dispatch;
	      }
	    }
	  };
	  if (!vue2) {
	    if (vue.beforeCreate) {
	      mixin.create = vue.beforeCreate;
	      delete vue.beforeCreate;
	    }
	    if (vue.beforeMount) {
	      vue.beforeCompile = vue.beforeMount;
	      delete vue.beforeMount;
	    }
	    if (vue.mounted) {
	      vue.ready = vue.mounted;
	      delete vue.mounted;
	    }
	  } else {
	    if (vue.beforeCompile) {
	      vue.beforeMount = vue.beforeCompile;
	      delete vue.beforeCompile;
	    }
	    if (vue.compiled) {
	      mixin.compiled = vue.compiled;
	      delete vue.compiled;
	    }
	    if (vue.ready) {
	      vue.mounted = vue.ready;
	      delete vue.ready;
	    }
	  }
	  if (!vue.mixins) {
	    vue.mixins = [];
	  }
	  vue.mixins.unshift(mixin);
	  return vue;
	}

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(250);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _EN, _FR;
	
	var _vue = __webpack_require__(206);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(540);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _apiBridge = __webpack_require__(23);
	
	var _apiBridge2 = _interopRequireDefault(_apiBridge);
	
	var _App = __webpack_require__(510);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(35);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueTheMask = __webpack_require__(547);
	
	var _vueTheMask2 = _interopRequireDefault(_vueTheMask);
	
	var _vueI18n = __webpack_require__(509);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _vueObserveVisibility = __webpack_require__(538);
	
	var _vueObserveVisibility2 = _interopRequireDefault(_vueObserveVisibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueObserveVisibility2.default);
	_vue2.default.use(_vueTheMask2.default);
	_vue2.default.use(_vueI18n2.default);
	
	_vue2.default.config.productionTip = false;
	
	console.log('launch');
	
	if (window.location && window.location.protocol == 'file:') {
	  _apiBridge2.default.useProxyApi = false;
	} else {
	  _apiBridge2.default.useProxyApi = true;
	}
	
	if (!("path" in Event.prototype)) Object.defineProperty(Event.prototype, "path", {
	  get: function get() {
	    var path = [];
	    var currentElem = this.target;
	    while (currentElem) {
	      path.push(currentElem);
	      currentElem = currentElem.parentElement;
	    }
	    if (path.indexOf(window) === -1 && path.indexOf(document) === -1) path.push(document);
	    if (path.indexOf(window) === -1) path.push(window);
	    return path;
	  }
	});
	
	var i18n = new _vueI18n2.default({
	  locale: 'EN',
	  fallbackLocale: 'EN',
	  messages: {
	    "EN": (_EN = {
	      "login": "Login",
	      "logout": "Logout",
	      "reload": "Reload",
	      "enter_store_number": "Enter Store Number to Login",
	      "store_number": "Store Number",
	      "build_version": "Build",
	      "native_version": "Version",
	      "ip_address": "IP Address",
	      "name": "Name",
	      "prev": "Prev",
	      "next": "Next",
	      "bump_order": "Bump Order",
	      "ready": "Ready",
	      "ready_orders": "Ready Orders",
	      "kds_orders": "KDS Orders",
	      "recall": "Recall",
	      "back": "Back",
	      "recall_order": "Recall Order",
	      "no_orders": "No Orders",
	      "no_recall_orders": "No Orders to Recall",
	      "no_pending_orders": "No Pending Orders",
	      "remaining": "Remaining",
	      "loading": "Loading",
	      "connection_error": "Connection Error",
	      "no_internet": "No Internet Connection",
	      "mobile_app_pickup": "Mobile App Pickup",
	      "delivery_pickup": "Delivery Pickup",
	      "prep": "Cooking"
	    }, (0, _defineProperty3.default)(_EN, 'ready', "Ready to Go!"), (0, _defineProperty3.default)(_EN, "cashier", "Visit Counter"), _EN),
	    "FR": (_FR = {
	      "login": "Connexion",
	      "logout": "Se déconnecter",
	      "reload": "Recharger",
	      "name": "Nom",
	      "enter_store_number": "Entrez le numéro du magasin pour vous connecter",
	      "store_number": "Numéro de restaurant",
	      "build_version": "Construction",
	      "native_version": "Version",
	      "ip_address": "Adresse IP",
	      "prev": "Préc",
	      "next": "Suiv",
	      "bump_order": "Passer Ordre",
	      "ready": "Prêt",
	      "ready_orders": "Commandes prêtes",
	      "recall": "Rappel",
	      "back": "Retour",
	      "recall_order": "Rappel Ordre",
	      "no_orders": "Pas de commande",
	      "no_recall_orders": "Aucun ordre de rappel",
	      "no_pending_orders": "Pas de commande",
	      "remaining": "Temps Restant",
	      "loading": "Chargement",
	      "connection_error": "Erreur de connexion",
	      "no_internet": "Pas de connexion Internet",
	      "mobile_app_pickup": "Pour l'appli mobile",
	      "delivery_pickup": "Pour livraison",
	      "prep": "Être cuit"
	    }, (0, _defineProperty3.default)(_FR, 'ready', "Prêt à partir!"), (0, _defineProperty3.default)(_FR, "cashier", "Voir la caisse"), _FR)
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  i18n: i18n,
	  router: _router2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(224)
	
	/* template */
	var __vue_template__ = __webpack_require__(532)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(500)
	
	/* script */
	__vue_exports__ = __webpack_require__(225)
	
	/* template */
	var __vue_template__ = __webpack_require__(533)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-81f5c9da"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(502)
	
	/* script */
	__vue_exports__ = __webpack_require__(226)
	
	/* template */
	var __vue_template__ = __webpack_require__(535)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b184d43e"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(227)
	
	/* template */
	var __vue_template__ = __webpack_require__(528)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(504)
	
	/* script */
	__vue_exports__ = __webpack_require__(228)
	
	/* template */
	var __vue_template__ = __webpack_require__(537)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dcdc7ad6"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(503)
	
	/* script */
	__vue_exports__ = __webpack_require__(229)
	
	/* template */
	var __vue_template__ = __webpack_require__(536)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c720a4e8"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(497)
	
	/* script */
	__vue_exports__ = __webpack_require__(230)
	
	/* template */
	var __vue_template__ = __webpack_require__(526)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-327ec334"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(501)
	
	/* script */
	__vue_exports__ = __webpack_require__(233)
	
	/* template */
	var __vue_template__ = __webpack_require__(534)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-994f58d8"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(234)
	
	/* template */
	var __vue_template__ = __webpack_require__(524)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(235)
	
	/* template */
	var __vue_template__ = __webpack_require__(525)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(498)
	
	/* script */
	__vue_exports__ = __webpack_require__(236)
	
	/* template */
	var __vue_template__ = __webpack_require__(529)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(496)
	
	/* script */
	__vue_exports__ = __webpack_require__(237)
	
	/* template */
	var __vue_template__ = __webpack_require__(523)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(238)
	
	/* template */
	var __vue_template__ = __webpack_require__(530)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 523:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.active || _vm.locked),
	      expression: "active||locked"
	    }],
	    class: ['spinner spinner-gritcode', _vm.spinnerSize, {
	      'spinner-fixed': _vm.fixed
	    }]
	  }, [_c('div', {
	    staticClass: "spinner-wrapper"
	  }, [_c('div', {
	    staticClass: "spinner-circle"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "spinner-text"
	  }, [_vm._v(_vm._s(_vm.text))])])])
	},staticRenderFns: []}

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c(_vm.isLi ? 'li' : 'div', {
	    directives: [{
	      name: "click-outside",
	      rawName: "v-click-outside",
	      value: (_vm.blur),
	      expression: "blur"
	    }],
	    tag: "div",
	    class: [{
	      open: _vm.show,
	      disabled: _vm.disabled,
	      dropdown: _vm.isLi,
	      'input-group-btn': _vm.inInput,
	      'btn-group': !_vm.isLi && !_vm.inInput
	    }]
	  }, [_vm._t("before"), _vm._v(" "), (_vm.isLi) ? _c('a', {
	    class: ['dropdown-toggle', _vm.buttonSize, {
	      disabled: _vm.disabled
	    }],
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        _vm.show = false
	      },
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.toggle($event)
	      }
	    }
	  }, [_vm._t("button", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
	    staticClass: "caret"
	  })], 2) : _c('button', {
	    class: ['btn btn-' + _vm.type, _vm.buttonSize, 'dropdown-toggle'],
	    attrs: {
	      "type": "button",
	      "disabled": _vm.disabled
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        _vm.show = false
	      },
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.toggle($event)
	      }
	    }
	  }, [_vm._t("button", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
	    staticClass: "caret"
	  })], 2), _vm._v(" "), _vm._t("dropdown-menu", [_c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_vm._t("default")], 2)])], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    class: ['navbar', 'navbar-' + _vm.type, _vm.placement === 'static' ? 'navbar-static-top' : 'navbar-fixed-' + _vm.placement]
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "navbar-header"
	  }, [(!_vm.$slots.collapse) ? _c('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "aria-expanded": "false"
	    },
	    on: {
	      "click": _vm.toggleCollapse
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })]) : _vm._e(), _vm._v(" "), _vm._t("collapse"), _vm._v(" "), _vm._t("brand")], 2), _vm._v(" "), _c('div', {
	    class: ['navbar-collapse', {
	      collapse: _vm.collapsed
	    }]
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.$slots.left) ? _c('ul', {
	    staticClass: "nav navbar-nav navbar-left"
	  }, [_vm._t("left")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.right) ? _c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [_vm._t("right")], 2) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "limiter"
	  }, [_c('div', {
	    staticClass: "container-login100",
	    staticStyle: {
	      "background-image": "url('static/assets/background.jpg')"
	    }
	  }, [_c('div', {
	    staticClass: "wrap-login100"
	  }, [_c('img', {
	    staticClass: "login-logo",
	    attrs: {
	      "src": "static/assets/logo-light.svg"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "login100-form validate-form"
	  }, [(_vm.displayLogin) ? _c('div', {
	    staticClass: "container-login100-form-btn"
	  }, [_c('button', {
	    staticClass: "login100-form-btn",
	    on: {
	      "click": function($event) {
	        return _vm.gotoLogin()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sign-in-alt "
	  }), _vm._v("\r\n                  " + _vm._s(_vm.$t('login')) + "\r\n                ")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "position": "fixed",
	      "left": "0px",
	      "bottom": "0px",
	      "width": "100%",
	      "z-index": "20"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "color": "#ffffff",
	      "padding-left": "20px"
	    }
	  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('build_version')) + ": " + _vm._s(_vm.build) + "\r\n              ")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "40px",
	      "padding-right": "20px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-block btn-lg btn-danger",
	    staticStyle: {
	      "height": "42px",
	      "padding": "9px",
	      "font-weight": "bold",
	      "border-radius": "50%",
	      "border": "solid 1px #ffffff"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.init()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-redo pull-left",
	    staticStyle: {
	      "margin": "2px -20px 0px 0px"
	    }
	  })])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.recallDisplay) ? _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "font-weight": "bold",
	      "font-size": "large",
	      "padding": "0px"
	    }
	  }, [_c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v("# " + _vm._s(_vm.checkNum))]), _vm._v(" "), (_vm.time) ? _c('span', {
	    staticClass: "pull-right",
	    style: ('font-size: smaller; color: ' + _vm.timeColour)
	  }, [_vm._v(_vm._s(_vm.time))]) : _vm._e(), _vm._v(" "), _c('br', {
	    attrs: {
	      "clear": "all"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "5px 0px 0px 0px",
	      "font-size": "medium"
	    }
	  }, [_vm._v(_vm._s(_vm.displayHeader(_vm.revenueType, _vm.lastName)))]), _vm._v(" "), (_vm.id) ? _c('div', {
	    staticStyle: {
	      "border": "solid green 1px",
	      "padding": "5px 10px",
	      "margin": "3px 0px 0px 0px",
	      "text-align": "left",
	      "font-size": "smaller"
	    }
	  }, [_vm._v("\r\n      " + _vm._s(_vm.$t('name')) + ":"), _c('br'), _vm._v(_vm._s(' ' + _vm.id) + "\r\n    ")]) : _vm._e()]) : _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "font-weight": "bold",
	      "font-size": "large"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "float": "left",
	      "margin-right": "20px"
	    }
	  }, [_vm._v("# " + _vm._s(_vm.checkNum) + "\r\n      "), (_vm.id) ? _c('span', {
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.id))]) : _vm._e()]), _vm._v(" "), (_vm.time) ? _c('span', {
	    style: ('float: right; color: ' + _vm.timeColour)
	  }, [_vm._v(" " + _vm._s(_vm.time))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "5px 2px 0px 2px"
	    }
	  }, [_vm._v(_vm._s(_vm.displayHeader(_vm.revenueType, _vm.lastName)))]), _vm._v(" "), (_vm.postPay && !_vm.closedDate) ? _c('div', {
	    staticStyle: {
	      "margin": "3px 0px -10px 0px"
	    }
	  }, [(!_vm.closedDate) ? _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("** NOT PAID **")]) : _vm._e()]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row center-block",
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.loginWithStoreNumber()
	      }
	    }
	  }, [(_vm.error) ? _c('h4', {
	    staticStyle: {
	      "color": "yellow",
	      "margin": "20px"
	    }
	  }, [_vm._v("\n    ERR: " + _vm._s(_vm.error) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "color": "white",
	      "text-align": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "font-size": "14pt"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('native_version')) + ": "), _c('b', [_vm._v(_vm._s(_vm.version))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "font-size": "14pt"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('build_version')) + ": "), _c('b', [_vm._v(_vm._s(_vm.build))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "font-size": "14pt"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber || '??'))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "font-size": "14pt"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('ip_address')) + ": "), _c('b', [_vm._v(_vm._s(_vm.ip))])])]), _vm._v(" "), _c('br', {
	    attrs: {
	      "clear": "all"
	    }
	  }), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "center-block",
	    staticStyle: {
	      "margin-top": "2em",
	      "width": "30%"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-block btn-success",
	    staticStyle: {
	      "height": "60px",
	      "padding-top": "14px",
	      "font-weight": "bold"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoBack()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-arrow-left pull-left",
	    staticStyle: {
	      "margin": "2px -20px 0px 0px"
	    }
	  }), _vm._v(_vm._s(_vm.$t('back')))])]), _vm._v(" "), _c('br', {
	    attrs: {
	      "clear": "all"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "center-block",
	    staticStyle: {
	      "margin-top": "1em",
	      "width": "30%"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-block btn-lg btn-danger",
	    staticStyle: {
	      "height": "60px",
	      "padding-top": "14px",
	      "font-weight": "bold"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.logout()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sign-out-alt pull-left",
	    staticStyle: {
	      "margin": "2px -20px 0px 0px"
	    }
	  }), _vm._v(_vm._s(_vm.$t('logout')))])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c(_vm.buttonStyle ? 'label' : 'div', {
	    tag: "div",
	    class: [(_vm.buttonStyle ? 'btn btn-' + _vm.typeColor : 'radio ' + _vm.typeColor), {
	      active: _vm.active,
	      disabled: _vm.disabled,
	      readonly: _vm.readonly
	    }],
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.toggle($event)
	      }
	    }
	  }, [(_vm.buttonStyle) ? [_c('input', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.readonly),
	      expression: "!readonly"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.check),
	      expression: "check"
	    }],
	    ref: "input",
	    attrs: {
	      "type": "radio",
	      "autocomplete": "off",
	      "name": _vm.name,
	      "readonly": _vm.readonly,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": _vm.checkedValue,
	      "checked": _vm._q(_vm.check, _vm.checkedValue)
	    },
	    on: {
	      "change": function($event) {
	        _vm.check = _vm.checkedValue
	      }
	    }
	  }), _vm._v(" "), _vm._t("default")] : _c('label', {
	    staticClass: "open"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.check),
	      expression: "check"
	    }],
	    ref: "input",
	    attrs: {
	      "type": "radio",
	      "autocomplete": "off",
	      "name": _vm.name,
	      "readonly": _vm.readonly,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": _vm.checkedValue,
	      "checked": _vm._q(_vm.check, _vm.checkedValue)
	    },
	    on: {
	      "change": function($event) {
	        _vm.check = _vm.checkedValue
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon dropdown-toggle",
	    class: [_vm.active ? 'btn-' + _vm.typeColor : '', {
	      bg: _vm.typeColor === 'default'
	    }]
	  }), _vm._v(" "), (_vm.active && _vm.typeColor === 'default') ? _c('span', {
	    staticClass: "icon"
	  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'btn-group': _vm.buttons, 'btn-group-justified': _vm.justified, 'btn-group-vertical': _vm.vertical
	    },
	    attrs: {
	      "data-toggle": _vm.buttons && 'buttons'
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    ref: "listContainer",
	    staticClass: "list-container",
	    style: ('visibility:' + _vm.visibility)
	  }, [(_vm.customerName) ? _c('div', {
	    staticStyle: {
	      "margin": "0px 40px 10px 0px",
	      "border": "solid green 1px",
	      "padding": "5px 15px"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('name')) + ":"), _c('br'), _vm._v(_vm._s(' ' + _vm.customerName) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.itemList), function(item, index) {
	    return _c('span', {
	      staticClass: "orderItem"
	    }, [(_vm.checkItemDisplay(item)) ? _c('li', [_c('div', {
	      style: ('margin: 0px 40px 10px 0px;' + _vm.checkHeader(item))
	    }, [(item.chk_cnt && item.chk_cnt > 1) ? _c('span', [_vm._v(_vm._s(item.chk_cnt) + " -")]) : _vm._e(), _vm._v(" "), (_vm.language == 'FR') ? _c('span', [_vm._v(_vm._s(item.name_2 || item.dtl_name))]) : _c('span', [_vm._v(_vm._s(item.dtl_name))]), _vm._v(" "), (item.items) ? _c('div', [_c('ul', {
	      style: ('list-style-type: none; margin: 0px 20px 0px -25px;' + _vm.calcFontSize(item))
	    }, _vm._l((item.items), function(subItem, index) {
	      return _c('li', [(_vm.checkItemDisplay(subItem)) ? _c('div', [(_vm.language == 'FR') ? _c('span', [_vm._v(_vm._s(subItem.name_2 || subItem.dtl_name) + " "), (subItem.qty && subItem.qty > 1) ? _c('span', [_vm._v(" (x" + _vm._s(subItem.qty) + ")")]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(subItem.dtl_name) + " "), (subItem.qty && subItem.qty > 1) ? _c('span', [_vm._v(" (x" + _vm._s(subItem.qty) + ")")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (subItem.items) ? _c('div', [_c('ul', {
	        staticStyle: {
	          "list-style-type": "none",
	          "margin-left": "-25px",
	          "font-size": "small"
	        }
	      }, _vm._l((subItem.items), function(subsubItem) {
	        return _c('li', [(_vm.checkItemDisplay(subsubItem)) ? _c('div', [(_vm.language == 'FR') ? _c('span', [_vm._v(_vm._s(subsubItem.name_2 || subsubItem.dtl_name))]) : _c('span', [_vm._v(_vm._s(subsubItem.dtl_name))]), _vm._v(" "), _c('br')]) : _vm._e()])
	      }), 0)]) : _vm._e()]) : _vm._e()])
	    }), 0)]) : _vm._e()])]) : _vm._e()])
	  })], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view', {
	    staticClass: "content-wrapper"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {}
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.currentBracket) ? _c('div', {
	    staticClass: "col-sm-6",
	    staticStyle: {
	      "font-size": "24px",
	      "color": "white"
	    }
	  }, [_vm._v("\r\n      " + _vm._s(_vm.currentBracket.fromTime || '00:00') + " - " + _vm._s(_vm.currentBracket.toTime || '00:00') + "\r\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6",
	    staticStyle: {
	      "font-size": "24px",
	      "color": "white",
	      "text-align": "right"
	    }
	  }, [_vm._v("\r\n      " + _vm._s(_vm.remainingLabel) + " "), _c('span', {
	    staticStyle: {
	      "color": "gold"
	    }
	  }, [_vm._v(_vm._s(_vm.elapsedTime))])])]), _vm._v(" "), (_vm.binList && _vm.binList.length) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "height": "90%",
	      "position": "relative"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('swiper', {
	    staticClass: "swiper-box",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [_vm._l((_vm.binList), function(bin) {
	    return _c('swiper-slide', {
	      staticClass: "swiper-item"
	    }, [_c('div', {
	      staticClass: "bin-tile"
	    }, [_c('table', {
	      staticStyle: {
	        "width": "100%",
	        "text-align": "center"
	      }
	    }, [_c('tr', [_c('td', {
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_c('h2', {
	      staticStyle: {
	        "padding": "0px",
	        "margin": "0px"
	      }
	    }, [_vm._v(_vm._s(bin.name))])])]), _vm._v(" "), _c('tr', [_c('td', {
	      staticStyle: {
	        "width": "20%"
	      }
	    }, [(bin.prevQty < bin.qty) ? _c('h1', {
	      staticStyle: {
	        "color": "maroon"
	      }
	    }, [_vm._v(_vm._s(bin.prevQty))]) : _c('h1', {
	      staticStyle: {
	        "color": "green"
	      }
	    }, [_vm._v(_vm._s(bin.prevQty))])]), _vm._v(" "), _c('td', [_c('h1', {
	      staticStyle: {
	        "font-size": "70px",
	        "font-weight": "bold"
	      }
	    }, [_vm._v(_vm._s(bin.qty))])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "20%"
	      }
	    }, [(bin.nextQty < bin.qty) ? _c('h1', {
	      staticStyle: {
	        "color": "maroon"
	      }
	    }, [_vm._v(_vm._s(bin.nextQty))]) : _c('h1', {
	      staticStyle: {
	        "color": "green"
	      }
	    }, [_vm._v(_vm._s(bin.nextQty))])])])])])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination",
	    attrs: {
	      "slot": "pagination"
	    },
	    slot: "pagination"
	  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "position": "fixed",
	      "bottom": "0px",
	      "width": "100%"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "40px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-block btn-lg btn-danger ",
	    staticStyle: {
	      "height": "42px",
	      "width": "42px",
	      "padding": "9px",
	      "font-weight": "bold",
	      "border-radius": "50%"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.init()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-redo pull-left",
	    staticStyle: {
	      "margin": "2px -20px 0px 0px"
	    }
	  })])]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-lg pull-right btn-default",
	    staticStyle: {
	      "height": "40px",
	      "width": "40px",
	      "padding": "9px",
	      "font-weight": "bold",
	      "border-radius": "50%",
	      "background-color": "#000",
	      "border": "none",
	      "color": "#fff"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoInfo()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-info-circle pull-left",
	    staticStyle: {
	      "margin": "2px 5px 0px 0px"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col col-sm-2 pull-right"
	  })])])
	},staticRenderFns: []}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "color": "white",
	      "margin": "0px 0px -5px 0px"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber))])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.refreshDelay),
	      expression: "refreshDelay"
	    }]
	  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "position": "fixed",
	      "height": "88%",
	      "width": "100%"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "margin": "5px"
	    }
	  }, [_c('swiper', {
	    staticClass: "panel-trans",
	    staticStyle: {
	      "height": "95%",
	      "width": "100%",
	      "padding": "10px 0px"
	    },
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [_vm._l((_vm.orderList), function(order, index) {
	    return _c('slide', {
	      staticStyle: {
	        "height": "25vh"
	      }
	    }, [_c('div', {
	      ref: 'order' + order.checkdetails.chk_num,
	      refInFor: true,
	      class: {
	        'panel': true,
	        'panel-default': true,
	        'box-shadow': true,
	        'panel-trans': _vm.panelAnimation[index],
	          'panel-shrinking': _vm.panelShrink[index],
	          'panel-fade': _vm.panelFade[index]
	      },
	      staticStyle: {
	        "margin": "0px",
	        "padding": "0px",
	        "height": "24vh"
	      },
	      attrs: {
	        "name": "panel"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleOrderSelect($event, order)
	        }
	      }
	    }, [_c('orderheader', {
	      staticClass: "panel-heading",
	      staticStyle: {
	        "padding": "8px 15px",
	        "height": "100%"
	      },
	      attrs: {
	        "recallDisplay": true,
	        "checkNum": order.checkdetails.chk_num,
	        "revenueType": order.checkdetails.name,
	        "firstName": order.checkdetails.first_name,
	        "lastName": order.checkdetails.last_name,
	        "id": order.checkdetails.id,
	        "time": order.checkdetails.displayTime,
	        "timeColour": order.checkdetails.timeColour
	      }
	    })], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination",
	    attrs: {
	      "slot": "pagination"
	    },
	    slot: "pagination"
	  })], 2)], 1)]) : _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "height": "87%",
	      "position": "fixed",
	      "width": "100%",
	      "text-align": "center"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "color": "white",
	      "margin": "20px"
	    }
	  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('no_recall_orders')) + "\r\n      ")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.refreshDelay),
	      expression: "!refreshDelay"
	    }],
	    staticClass: "row",
	    staticStyle: {
	      "height": "87%",
	      "position": "fixed",
	      "width": "100%",
	      "text-align": "center"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "color": "white",
	      "margin": "20px"
	    }
	  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('loading')) + "...\r\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "position": "fixed",
	      "bottom": "5px",
	      "margin": "0px 0px 0px -1px",
	      "width": "100%",
	      "z-index": "20"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "padding": "0px 20px 0px 0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-block btn-success",
	    staticStyle: {
	      "height": "60px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoMain()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-arrow-left pull-left",
	    staticStyle: {
	      "margin": "2px 5px 0px 0px"
	    }
	  }), _vm._v(_vm._s(_vm.$t('back')) + "\r\n                ")])]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "0px 10px"
	    }
	  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
	    staticClass: "btn btn-block btn-lg btn-default button-prev btn-modified pull-right",
	    staticStyle: {
	      "width": "120px",
	      "background-color": "#00ffff"
	    },
	    attrs: {
	      "slot": "button-prev"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deselectOrder()
	      }
	    },
	    slot: "button-prev"
	  }, [_c('i', {
	    staticClass: "fas fa-chevron-left"
	  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + "\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "btn btn-block btn-lg btn-danger",
	    staticStyle: {
	      "height": "60px",
	      "width": "100%"
	    },
	    attrs: {
	      "disabled": !_vm.selectedOrder
	    },
	    on: {
	      "click": function($event) {
	        return _vm.recallLaunch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-undo pull-left",
	    staticStyle: {
	      "margin": "2px 0px 0px 0px"
	    }
	  }), _vm._v(_vm._s(_vm.$t('recall_order')) + "\r\n                ")])]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "0px 10px"
	    }
	  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
	    staticClass: "btn btn-block btn-lg  btn-default button-next btn-modified",
	    staticStyle: {
	      "width": "120px",
	      "background-color": "#00ffff"
	    },
	    attrs: {
	      "slot": "button-next"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deselectOrder()
	      }
	    },
	    slot: "button-next"
	  }, [_vm._v(_vm._s(_vm.$t('next')) + " "), _c('i', {
	    staticClass: "fas fa-chevron-right"
	  })]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "0px 20px 0px 0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-lg pull-right btn-default",
	    staticStyle: {
	      "height": "40px",
	      "width": "40px",
	      "padding": "9px",
	      "font-weight": "bold",
	      "border-radius": "50%",
	      "background-color": "#000",
	      "border": "none",
	      "color": "#fff"
	    },
	    attrs: {
	      "disabled": _vm.logoutTimeout
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoInfo()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-info-circle pull-left",
	    staticStyle: {
	      "margin": "2px 5px 0px 0px"
	    }
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-left",
	    staticStyle: {
	      "color": "white",
	      "font-size": "larger",
	      "font-weight": "bold"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#d9534f"
	    }
	  }, [_vm._v("KDS - Order Recall")])])
	}]}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticStyle: {
	      "position": "absolute",
	      "color": "white",
	      "right": "10px",
	      "top": "2px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber))])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    style: (_vm.bannerStyle)
	  }, [_c('img', {
	    staticClass: "gfb-logo",
	    attrs: {
	      "src": _vm.logoPath
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "height": "87%",
	      "position": "fixed",
	      "width": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('br', {
	    attrs: {
	      "clear": "all"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "panel-trans pull-left",
	    staticStyle: {
	      "height": "100%",
	      "width": "50%",
	      "padding-right": "1%",
	      "border-right": "solid 2px",
	      "min-height": "88vh"
	    }
	  }, [(_vm.headerLeft) ? _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "font-size": "4.5vh",
	      "font-weight": "800",
	      "border-bottom": "solid 2px",
	      "border-color": "black",
	      "margin": "-15px 15px 15px 15px",
	      "padding-top": "0.8vh",
	      "padding-bottom": "0.1vh",
	      "background-color": "#E87524",
	      "color": "white"
	    }
	  }, [(_vm.logoLeftPath) ? _c('img', {
	    staticStyle: {
	      "margin": "-1vh 3vh 1vh 0px",
	      "height": "8vh"
	    },
	    attrs: {
	      "src": _vm.logoLeftPath
	    }
	  }) : _vm._e(), _vm._v("\r\n          " + _vm._s(_vm.headerLeft) + "\r\n        ")]) : _vm._e(), _vm._v(" "), _c('swiper', {
	    ref: "panelFlipperLeft",
	    attrs: {
	      "options": _vm.swiperOptionh
	    }
	  }, _vm._l((_vm.pagesLeft), function(page, pIndex) {
	    return _c('slide', [_c('swiper', {
	      ref: 'orderPanelLeft' + pIndex,
	      refInFor: true,
	      staticStyle: {
	        "padding-left": "2%"
	      },
	      attrs: {
	        "options": _vm.swiperOption
	      }
	    }, [_vm._l((_vm.pagesLeft[pIndex]), function(order, index) {
	      return (!order.hidden) ? _c('slide', {
	        ref: 'slide' + order.checkdetails.chk_num,
	        refInFor: true
	      }, [_c('div', {
	        ref: 'order' + order.checkdetails.chk_num,
	        refInFor: true,
	        class: {
	          'panel': true,
	          'panel-default': true,
	          'box-shadow': true,
	          'in-prep': (order.status.indexOf('prep') >= 0),
	          'pulse-order': (order.status.indexOf('ready') >= 0),
	          'ready': (order.status.indexOf('ready') >= 0),
	          'cashier': (order.status.indexOf('cashier') >= 0),
	          'panel-trans': _vm.panelAnimation[index],
	            'panel-shrinking': _vm.panelShrink[index],
	            'panel-fade': _vm.panelFade[index]
	        },
	        staticStyle: {
	          "margin": "2px 0px",
	          "border": "none"
	        }
	      }, [_c('div', {
	        staticClass: "panel-heading"
	      }, [_c('span', {
	        staticClass: "display-name truncate"
	      }, [_vm._v(_vm._s(order.displayName))]), _vm._v(" "), _c('span', {
	        staticClass: "order-status",
	        style: ('color: ' + order.color + ';')
	      }, [_vm._v(_vm._s(_vm.$t(order.status) || ''))])])]), _vm._v(" "), _c('div', {
	        staticStyle: {
	          "display": "none"
	        }
	      }, [_c('orderitems', {
	        ref: 'orderItems' + order.checkdetails.chk_num,
	        refInFor: true,
	        attrs: {
	          "orderId": parseInt(order.checkdetails.chk_num),
	          "customerName": order.checkdetails.id,
	          "inGFB": true
	        },
	        on: {
	          "updateOrder": _vm.updateOrder,
	          "hideOrder": _vm.hideOrder
	        }
	      })], 1)]) : _vm._e()
	    }), _vm._v(" "), _c('div', {
	      staticClass: "swiper-pagination",
	      attrs: {
	        "slot": "pagination"
	      },
	      slot: "pagination"
	    })], 2)], 1)
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "panel-trans pull-right",
	    staticStyle: {
	      "height": "100%",
	      "width": "49%",
	      "padding-right": "1%"
	    }
	  }, [(_vm.headerRight) ? _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "font-size": "4.5vh",
	      "font-weight": "800",
	      "border-bottom": "solid 2px",
	      "border-color": "black",
	      "margin": "-15px 15px 15px 15px",
	      "padding-top": "0.8vh",
	      "padding-bottom": "0.1vh",
	      "background-color": "#E87524",
	      "color": "white"
	    }
	  }, [(_vm.logoRightPath) ? _c('img', {
	    staticStyle: {
	      "margin": "0vh 3vh 0vh 0px",
	      "height": "8vh"
	    },
	    attrs: {
	      "src": _vm.logoRightPath
	    }
	  }) : _vm._e(), _vm._v("\r\n          " + _vm._s(_vm.headerRight) + "\r\n        ")]) : _vm._e(), _vm._v(" "), _c('swiper', {
	    ref: "panelFlipperRight",
	    attrs: {
	      "options": _vm.swiperOptionh
	    }
	  }, _vm._l((_vm.pagesRight), function(page, pIndex) {
	    return _c('slide', [_c('swiper', {
	      ref: 'orderPanelRight' + pIndex,
	      refInFor: true,
	      staticStyle: {
	        "padding-left": "2%"
	      },
	      attrs: {
	        "options": _vm.swiperOption
	      }
	    }, [_vm._l((_vm.pagesRight[pIndex]), function(order, index) {
	      return (!order.hidden) ? _c('slide', {
	        ref: 'slide' + order.checkdetails.chk_num,
	        refInFor: true
	      }, [_c('div', {
	        ref: 'order' + order.checkdetails.chk_num,
	        refInFor: true,
	        class: {
	          'panel': true,
	          'panel-default': true,
	          'box-shadow': true,
	          'in-prep': (order.status.indexOf('prep') >= 0),
	          'pulse-order': (order.status.indexOf('ready') >= 0),
	          'ready': (order.status.indexOf('ready') >= 0),
	          'cashier': (order.status.indexOf('cashier') >= 0),
	          'panel-trans': _vm.panelAnimation[index],
	            'panel-shrinking': _vm.panelShrink[index],
	            'panel-fade': _vm.panelFade[index]
	        },
	        staticStyle: {
	          "margin": "2px 0px",
	          "border": "none"
	        }
	      }, [_c('div', {
	        staticClass: "panel-heading"
	      }, [_c('span', {
	        staticClass: "display-name truncate"
	      }, [_vm._v(_vm._s(order.displayName))]), _vm._v(" "), _c('span', {
	        staticClass: "order-status",
	        style: ('color: ' + order.color + ';')
	      }, [_vm._v(_vm._s(_vm.$t(order.status) || ''))])])]), _vm._v(" "), _c('div', {
	        staticStyle: {
	          "display": "none"
	        }
	      }, [_c('orderitems', {
	        ref: 'orderItems' + order.checkdetails.chk_num,
	        refInFor: true,
	        attrs: {
	          "orderId": parseInt(order.checkdetails.chk_num),
	          "customerName": order.checkdetails.id,
	          "inGFB": true
	        },
	        on: {
	          "updateOrder": _vm.updateOrder,
	          "hideOrder": _vm.hideOrder
	        }
	      })], 1)]) : _vm._e()
	    }), _vm._v(" "), _c('div', {
	      staticClass: "swiper-pagination",
	      attrs: {
	        "slot": "pagination"
	      },
	      slot: "pagination"
	    })], 2)], 1)
	  }), 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "position": "fixed",
	      "bottom": "5px",
	      "width": "100%",
	      "z-index": "20"
	    }
	  }, [_c('div', {
	    staticClass: "col col-sm-2 pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-lg pull-right btn-default",
	    staticStyle: {
	      "height": "24px",
	      "width": "24px",
	      "padding": "0px 3px 2px 3px",
	      "font-weight": "bold",
	      "border-radius": "50%",
	      "background-color": "gold",
	      "border": "none",
	      "color": "#ED1C24"
	    },
	    attrs: {
	      "disabled": _vm.logoutTimeout
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoInfo()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-info-circle pull-left",
	    staticStyle: {
	      "margin": "2px 5px 0px 0px"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "limiter"
	  }, [_c('div', {
	    staticClass: "container-login100",
	    staticStyle: {
	      "background-image": "url('static/assets/background.jpg')"
	    }
	  }, [_c('div', {
	    staticClass: "wrap-login100"
	  }, [_c('img', {
	    staticClass: "login-logo",
	    attrs: {
	      "src": "static/assets/logo-light.svg"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "login100-form validate-form"
	  }, [_c('div', {
	    staticClass: "wrap-input100 validate-input"
	  }, [_c('the-mask', {
	    ref: "inStoreNumber",
	    staticClass: "input100",
	    attrs: {
	      "type": "tel",
	      "maxlength": "4",
	      "mask": "####",
	      "placeholder": _vm.$t('enter_store_number')
	    },
	    model: {
	      value: (_vm.storeNumber),
	      callback: function($$v) {
	        _vm.storeNumber = $$v
	      },
	      expression: "storeNumber"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "container-login100-form-btn"
	  }, [_c('button', {
	    staticClass: "login100-form-btn",
	    on: {
	      "click": function($event) {
	        return _vm.loginWithStoreNumber('K')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sign-in-alt "
	  }), _vm._v("\r\n                  KDS\r\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "login100-form-btn",
	    on: {
	      "click": function($event) {
	        return _vm.loginWithStoreNumber('B')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sign-in-alt "
	  }), _vm._v("\r\n                  BIN\r\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "login100-form-btn",
	    on: {
	      "click": function($event) {
	        return _vm.loginWithStoreNumber('G')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sign-in-alt "
	  }), _vm._v("\r\n                  GFB\r\n                ")])])])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "position": "fixed",
	      "left": "0px",
	      "bottom": "0px",
	      "width": "100%",
	      "z-index": "20"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "color": "#ffffff",
	      "padding-left": "20px"
	    }
	  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('build_version')) + ": " + _vm._s(_vm.build) + "\r\n              ")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "width": "40px",
	      "padding-right": "20px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-block btn-lg btn-danger",
	    staticStyle: {
	      "height": "42px",
	      "padding": "9px",
	      "font-weight": "bold",
	      "border-radius": "50%",
	      "border": "solid 1px #ffffff"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.reload()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-redo pull-left",
	    staticStyle: {
	      "margin": "2px -20px 0px 0px"
	    }
	  })])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "color": "white",
	      "margin": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "pull-left",
	    staticStyle: {
	      "color": "white",
	      "font-size": "larger",
	      "font-weight": "bold"
	    }
	  }, [(_vm.readyOrdersDisplay) ? _c('span', {
	    staticStyle: {
	      "color": "gold"
	    }
	  }, [_vm._v("KDS - Ready for Pickup")]) : _c('span', {
	    staticStyle: {
	      "color": "#caffc4"
	    }
	  }, [_vm._v("KDS - Need Preparation")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    staticStyle: {
	      "margin": "2px 7px 1px 7px",
	      "width": "2.5em",
	      "font-weight": "bolder",
	      "background-color": "floralwhite",
	      "color": "darkred"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleDetailView()
	      }
	    }
	  }, [_vm._v(_vm._s((_vm.detailView) ? '-' : '+'))])]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber))])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.refreshDelay),
	      expression: "refreshDelay"
	    }]
	  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "height": "87%",
	      "position": "fixed",
	      "width": "100%"
	    }
	  }, [(_vm.detailView) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('swiper', {
	    ref: "orderSwiper",
	    staticClass: "panel-trans",
	    staticStyle: {
	      "height": "100%",
	      "padding-top": "5px"
	    },
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [_vm._l((_vm.orderList), function(order, index) {
	    return (!order.hidden) ? _c('slide', {
	      ref: 'slide' + order.checkdetails.chk_num,
	      refInFor: true
	    }, [_c('div', {
	      directives: [{
	        name: "observe-visibility",
	        rawName: "v-observe-visibility",
	        value: ({
	          callback: _vm.visibilityChanged,
	          once: true,
	        }),
	        expression: "{\r\n                    callback: visibilityChanged,\r\n                    once: true,\r\n                  }"
	      }],
	      ref: 'order' + order.checkdetails.chk_num,
	      refInFor: true,
	      class: {
	        'panel': true,
	        'panel-default': true,
	        'box-shadow': true,
	        'ready': _vm.readyOrdersDisplay,
	        'panel-trans': _vm.panelAnimation[index],
	          'panel-shrinking': _vm.panelShrink[index],
	          'panel-fade': _vm.panelFade[index]
	      },
	      staticStyle: {
	        "width": "230px"
	      },
	      attrs: {
	        "id": order.checkdetails.chk_num
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleOrderSelect(order)
	        }
	      }
	    }, [_c('orderheader', {
	      staticClass: "panel-heading",
	      attrs: {
	        "checkNum": order.checkdetails.chk_num,
	        "revenueType": order.checkdetails.name,
	        "firstName": order.checkdetails.first_name,
	        "lastName": order.checkdetails.last_name,
	        "time": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].time : '',
	        "timeColour": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].colour : '',
	        "postPay": order.postPay,
	        "closedDate": order.checkdetails.chk_clsd_date_time
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "panel-body",
	      staticStyle: {
	        "height": "80%",
	        "width": "100%"
	      }
	    }, [_c('div', {
	      ref: 'loader' + order.checkdetails.chk_num,
	      refInFor: true,
	      staticClass: "loader",
	      staticStyle: {
	        "display": "none"
	      }
	    }), _vm._v(" "), _c('orderitems', {
	      ref: 'orderItems' + order.checkdetails.chk_num,
	      refInFor: true,
	      attrs: {
	        "orderId": parseInt(order.checkdetails.chk_num),
	        "customerName": order.checkdetails.id
	      },
	      on: {
	        "updateOrder": _vm.updateOrder,
	        "hideOrder": _vm.hideOrder
	      }
	    })], 1)], 1)]) : _vm._e()
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination",
	    attrs: {
	      "slot": "pagination"
	    },
	    slot: "pagination"
	  })], 2)], 1) : _c('div', [_c('div', {
	    staticStyle: {
	      "margin": "5px"
	    }
	  }, [_c('swiper', {
	    staticClass: "panel-trans",
	    staticStyle: {
	      "height": "95%",
	      "width": "100%",
	      "padding": "10px 0px"
	    },
	    attrs: {
	      "options": _vm.swiperOptionDetailless
	    }
	  }, [_vm._l((_vm.orderList), function(order, index) {
	    return _c('slide', {
	      staticStyle: {
	        "height": "25vh"
	      }
	    }, [_c('div', {
	      ref: 'order' + order.checkdetails.chk_num,
	      refInFor: true,
	      class: {
	        'panel': true,
	        'panel-default': true,
	        'box-shadow': true,
	        'ready': _vm.readyOrdersDisplay,
	        'panel-trans': _vm.panelAnimation[index],
	          'panel-shrinking': _vm.panelShrink[index],
	          'panel-fade': _vm.panelFade[index]
	      },
	      staticStyle: {
	        "margin": "0px",
	        "padding": "0px",
	        "height": "24vh"
	      },
	      attrs: {
	        "id": order.checkdetails.chk_num,
	        "name": "panel"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleOrderSelect(order)
	        }
	      }
	    }, [_c('orderheader', {
	      staticClass: "panel-heading",
	      staticStyle: {
	        "height": "100%"
	      },
	      attrs: {
	        "checkNum": order.checkdetails.chk_num,
	        "revenueType": order.checkdetails.name,
	        "firstName": order.checkdetails.first_name,
	        "lastName": order.checkdetails.last_name,
	        "time": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].time : '',
	        "timeColour": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].colour : '',
	        "postPay": order.postPay,
	        "closedDate": order.checkdetails.chk_clsd_date_time,
	        "recallDisplay": true,
	        "id": order.checkdetails.id
	      }
	    })], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination",
	    attrs: {
	      "slot": "pagination"
	    },
	    slot: "pagination"
	  })], 2)], 1)])]) : _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "height": "87%",
	      "position": "fixed",
	      "width": "100%",
	      "text-align": "center"
	    }
	  }, [(_vm.error) ? _c('h3', {
	    staticStyle: {
	      "color": "white",
	      "margin": "20px"
	    }
	  }, [_vm._v("\r\n        " + _vm._s(_vm.error) + "\r\n      ")]) : _c('h3', {
	    staticStyle: {
	      "color": "white",
	      "margin": "20px"
	    }
	  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('no_orders')) + "\r\n      ")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.refreshDelay),
	      expression: "!refreshDelay"
	    }],
	    staticClass: "row",
	    staticStyle: {
	      "height": "87%",
	      "position": "fixed",
	      "width": "100%",
	      "text-align": "center"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "color": "white",
	      "margin": "20px"
	    }
	  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('loading')) + "...\r\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "position": "fixed",
	      "bottom": "5px",
	      "margin": "0px 0px -4px -1px",
	      "width": "100%",
	      "z-index": "20"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('tr', [_c('td', {
	    staticStyle: {
	      "padding": "0px 20px 0px 0px"
	    }
	  }, [(_vm.readyOrdersDisplay) ? _c('button', {
	    staticClass: "btn btn-lg btn-block",
	    staticStyle: {
	      "height": "60px",
	      "width": "185px",
	      "background-color": "white"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoKDSprep()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-arrow-left pull-left",
	    staticStyle: {
	      "margin": "2px 5px 0px 0px"
	    }
	  }), _vm._v("Go to Prep\r\n                ")]) : (_vm.showReady) ? _c('button', {
	    staticClass: "btn btn-lg btn-block ",
	    staticStyle: {
	      "height": "60px",
	      "width": "185px",
	      "background-color": "gold"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoKDSready()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-arrow-right pull-left",
	    staticStyle: {
	      "margin": "2px 10px 0px 0px"
	    }
	  }), _vm._v("Go to Ready\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "0px 10px"
	    }
	  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
	    staticClass: "btn btn-block btn-lg btn-default button-prev btn-modified pull-right",
	    staticStyle: {
	      "width": "120px",
	      "background-color": "#00ffff"
	    },
	    attrs: {
	      "slot": "button-prev"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deselectOrder(_vm.selectedOrder)
	      }
	    },
	    slot: "button-prev"
	  }, [_c('i', {
	    staticClass: "fas fa-chevron-left"
	  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + "\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.actionButton == 'bump') ? _c('button', {
	    staticClass: "btn btn-block btn-lg btn-success",
	    style: ('height: 60px; width: 100%;' +
	      ((_vm.readyOrdersDisplay || !_vm.showReady) ? '' : 'background-color: darkorange;')),
	    attrs: {
	      "disabled": !_vm.selectedOrder
	    },
	    on: {
	      "click": function($event) {
	        return _vm.actionLaunch('bump')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-external-link-alt pull-left",
	    staticStyle: {
	      "margin": "2px 0px 0px 0px"
	    }
	  }), _vm._v(_vm._s(_vm.$t('bump_order')) + "\r\n                ")]) : (_vm.actionButton == 'ready') ? _c('button', {
	    staticClass: "btn btn-block btn-lg btn-success",
	    staticStyle: {
	      "height": "60px",
	      "width": "100%"
	    },
	    attrs: {
	      "disabled": !_vm.selectedOrder
	    },
	    on: {
	      "click": function($event) {
	        return _vm.actionLaunch('ready')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-external-link-alt pull-left",
	    staticStyle: {
	      "margin": "2px 10px 0px 0px"
	    }
	  }), _vm._v("Mark as Ready\r\n                ")]) : (_vm.actionButton == 'return') ? _c('button', {
	    staticClass: "btn btn-block btn-lg btn-success",
	    staticStyle: {
	      "height": "60px",
	      "width": "100%",
	      "background-color": "darkorange"
	    },
	    attrs: {
	      "disabled": !_vm.selectedOrder
	    },
	    on: {
	      "click": function($event) {
	        return _vm.actionLaunch('recall')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-history pull-left",
	    staticStyle: {
	      "margin": "2px 10px 0px 0px"
	    }
	  }), _vm._v("Return To Prep\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "0px 10px"
	    }
	  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
	    staticClass: "btn btn-block btn-lg  btn-default button-next btn-modified",
	    staticStyle: {
	      "width": "120px",
	      "background-color": "#00ffff"
	    },
	    attrs: {
	      "slot": "button-next"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deselectOrder(_vm.selectedOrder)
	      }
	    },
	    slot: "button-next"
	  }, [_vm._v(_vm._s(_vm.$t('next')) + " "), _c('i', {
	    staticClass: "fas fa-chevron-right"
	  })]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "padding": "0px 20px 0px 0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-block btn-danger pull-right",
	    staticStyle: {
	      "height": "60px",
	      "width": "180px",
	      "margin": "5px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.gotoRecallList()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-history pull-left",
	    staticStyle: {
	      "margin": "2px 5px 0px 0px"
	    }
	  }), _vm._v("Go to Recall\r\n                ")])])])])])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/main.676a313ad26e31c887b5.js